function Tr(e) {
  return Object.keys(e).reduce((n, r) => {
    const i = e[r];
    return n[r] = Object.assign({}, i), zn(i.value) && !Fr(i.value) && !Array.isArray(i.value) && (n[r].value = Object.assign({}, i.value)), Array.isArray(i.value) && (n[r].value = i.value.slice(0)), n;
  }, {});
}
function kr(e) {
  return e ? Object.keys(e).reduce((n, r) => {
    const i = e[r];
    return n[r] = zn(i) && "value" in i ? i : {
      value: i
    }, n[r].attribute || (n[r].attribute = $r(r)), n[r].parse = "parse" in n[r] ? n[r].parse : typeof n[r].value != "string", n;
  }, {}) : {};
}
function Dr(e) {
  return Object.keys(e).reduce((n, r) => (n[r] = e[r].value, n), {});
}
function Lr(e, t) {
  const n = Tr(t);
  return Object.keys(t).forEach((i) => {
    const o = n[i], s = e.getAttribute(o.attribute), a = e[i];
    s && (o.value = o.parse ? Kn(s) : s), a != null && (o.value = Array.isArray(a) ? a.slice(0) : a), o.reflect && un(e, o.attribute, o.value), Object.defineProperty(e, i, {
      get() {
        return o.value;
      },
      set(f) {
        const l = o.value;
        o.value = f, o.reflect && un(this, o.attribute, o.value);
        for (let c = 0, u = this.__propertyChangedCallbacks.length; c < u; c++)
          this.__propertyChangedCallbacks[c](i, f, l);
      },
      enumerable: !0,
      configurable: !0
    });
  }), n;
}
function Kn(e) {
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return e;
    }
}
function un(e, t, n) {
  if (n == null || n === !1)
    return e.removeAttribute(t);
  let r = JSON.stringify(n);
  e.__updating[t] = !0, r === "true" && (r = ""), e.setAttribute(t, r), Promise.resolve().then(() => delete e.__updating[t]);
}
function $r(e) {
  return e.replace(/\.?([A-Z]+)/g, (t, n) => "-" + n.toLowerCase()).replace("_", "-").replace(/^-/, "");
}
function zn(e) {
  return e != null && (typeof e == "object" || typeof e == "function");
}
function Fr(e) {
  return Object.prototype.toString.call(e) === "[object Function]";
}
function _r(e) {
  return typeof e == "function" && e.toString().indexOf("class") === 0;
}
let St;
function Ir(e, t) {
  const n = Object.keys(t);
  return class extends e {
    static get observedAttributes() {
      return n.map((i) => t[i].attribute);
    }
    constructor() {
      super(), this.__initialized = !1, this.__released = !1, this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = {};
    }
    connectedCallback() {
      if (this.__initialized)
        return;
      this.__releaseCallbacks = [], this.__propertyChangedCallbacks = [], this.__updating = {}, this.props = Lr(this, t);
      const i = Dr(this.props), o = this.Component, s = St;
      try {
        St = this, this.__initialized = !0, _r(o) ? new o(i, {
          element: this
        }) : o(i, {
          element: this
        });
      } finally {
        St = s;
      }
    }
    async disconnectedCallback() {
      if (await Promise.resolve(), this.isConnected)
        return;
      this.__propertyChangedCallbacks.length = 0;
      let i = null;
      for (; i = this.__releaseCallbacks.pop(); )
        i(this);
      delete this.__initialized, this.__released = !0;
    }
    attributeChangedCallback(i, o, s) {
      if (this.__initialized && !this.__updating[i] && (i = this.lookupProp(i), i in t)) {
        if (s == null && !this[i])
          return;
        this[i] = t[i].parse ? Kn(s) : s;
      }
    }
    lookupProp(i) {
      if (t)
        return n.find((o) => i === o || i === t[o].attribute);
    }
    get renderRoot() {
      return this.shadowRoot || this.attachShadow({
        mode: "open"
      });
    }
    addReleaseCallback(i) {
      this.__releaseCallbacks.push(i);
    }
    addPropertyChangedCallback(i) {
      this.__propertyChangedCallbacks.push(i);
    }
  };
}
function jr(e, t = {}, n = {}) {
  const {
    BaseElement: r = HTMLElement,
    extension: i
  } = n;
  return (o) => {
    if (!e)
      throw new Error("tag is required to register a Component");
    let s = customElements.get(e);
    return s ? (s.prototype.Component = o, s) : (s = Ir(r, kr(t)), s.prototype.Component = o, s.prototype.registeredTag = e, customElements.define(e, s, i), s);
  };
}
const Rr = (e, t) => e === t, H = Symbol("solid-proxy"), jt = Symbol("solid-track"), Je = {
  equals: Rr
};
let Wn = Yn;
const ue = 1, Qe = 2, Vn = {
  owned: null,
  cleanups: null,
  context: null,
  owner: null
};
var L = null;
let Ct = null, Mr = null, F = null, K = null, oe = null, pt = 0;
function Ye(e, t) {
  const n = F, r = L, i = e.length === 0, o = t === void 0 ? r : t, s = i ? Vn : {
    owned: null,
    cleanups: null,
    context: o ? o.context : null,
    owner: o
  }, a = i ? e : () => e(() => U(() => yt(s)));
  L = s, F = null;
  try {
    return Ae(a, !0);
  } finally {
    F = n, L = r;
  }
}
function X(e, t) {
  t = t ? Object.assign({}, Je, t) : Je;
  const n = {
    value: e,
    observers: null,
    observerSlots: null,
    comparator: t.equals || void 0
  }, r = (i) => (typeof i == "function" && (i = i(n.value)), Xn(n, i));
  return [qn.bind(n), r];
}
function Y(e, t, n) {
  const r = en(e, t, !1, ue);
  ze(r);
}
function et(e, t, n) {
  Wn = Vr;
  const r = en(e, t, !1, ue);
  (!n || !n.render) && (r.user = !0), oe ? oe.push(r) : ze(r);
}
function V(e, t, n) {
  n = n ? Object.assign({}, Je, n) : Je;
  const r = en(e, t, !0, 0);
  return r.observers = null, r.observerSlots = null, r.comparator = n.equals || void 0, ze(r), qn.bind(r);
}
function Un(e) {
  return Ae(e, !1);
}
function U(e) {
  if (F === null)
    return e();
  const t = F;
  F = null;
  try {
    return e();
  } finally {
    F = t;
  }
}
function Qt(e) {
  et(() => U(e));
}
function gt(e) {
  return L === null || (L.cleanups === null ? L.cleanups = [e] : L.cleanups.push(e)), e;
}
function Rt() {
  return F;
}
function Br(e, t) {
  const n = Symbol("context");
  return {
    id: n,
    Provider: Gr(n),
    defaultValue: e
  };
}
function Kr(e) {
  return L && L.context && L.context[e.id] !== void 0 ? L.context[e.id] : e.defaultValue;
}
function Gn(e) {
  const t = V(e), n = V(() => Mt(t()));
  return n.toArray = () => {
    const r = n();
    return Array.isArray(r) ? r : r != null ? [r] : [];
  }, n;
}
function qn() {
  if (this.sources && this.state)
    if (this.state === ue)
      ze(this);
    else {
      const e = K;
      K = null, Ae(() => nt(this), !1), K = e;
    }
  if (F) {
    const e = this.observers ? this.observers.length : 0;
    F.sources ? (F.sources.push(this), F.sourceSlots.push(e)) : (F.sources = [this], F.sourceSlots = [e]), this.observers ? (this.observers.push(F), this.observerSlots.push(F.sources.length - 1)) : (this.observers = [F], this.observerSlots = [F.sources.length - 1]);
  }
  return this.value;
}
function Xn(e, t, n) {
  let r = e.value;
  return (!e.comparator || !e.comparator(r, t)) && (e.value = t, e.observers && e.observers.length && Ae(() => {
    for (let i = 0; i < e.observers.length; i += 1) {
      const o = e.observers[i], s = Ct && Ct.running;
      s && Ct.disposed.has(o), (s ? !o.tState : !o.state) && (o.pure ? K.push(o) : oe.push(o), o.observers && Hn(o)), s || (o.state = ue);
    }
    if (K.length > 1e6)
      throw K = [], new Error();
  }, !1)), t;
}
function ze(e) {
  if (!e.fn)
    return;
  yt(e);
  const t = pt;
  zr(
    e,
    e.value,
    t
  );
}
function zr(e, t, n) {
  let r;
  const i = L, o = F;
  F = L = e;
  try {
    r = e.fn(t);
  } catch (s) {
    return e.pure && (e.state = ue, e.owned && e.owned.forEach(yt), e.owned = null), e.updatedAt = n + 1, Zn(s);
  } finally {
    F = o, L = i;
  }
  (!e.updatedAt || e.updatedAt <= n) && (e.updatedAt != null && "observers" in e ? Xn(e, r) : e.value = r, e.updatedAt = n);
}
function en(e, t, n, r = ue, i) {
  const o = {
    fn: e,
    state: r,
    updatedAt: null,
    owned: null,
    sources: null,
    sourceSlots: null,
    cleanups: null,
    value: t,
    owner: L,
    context: L ? L.context : null,
    pure: n
  };
  return L === null || L !== Vn && (L.owned ? L.owned.push(o) : L.owned = [o]), o;
}
function tt(e) {
  if (e.state === 0)
    return;
  if (e.state === Qe)
    return nt(e);
  if (e.suspense && U(e.suspense.inFallback))
    return e.suspense.effects.push(e);
  const t = [e];
  for (; (e = e.owner) && (!e.updatedAt || e.updatedAt < pt); )
    e.state && t.push(e);
  for (let n = t.length - 1; n >= 0; n--)
    if (e = t[n], e.state === ue)
      ze(e);
    else if (e.state === Qe) {
      const r = K;
      K = null, Ae(() => nt(e, t[0]), !1), K = r;
    }
}
function Ae(e, t) {
  if (K)
    return e();
  let n = !1;
  t || (K = []), oe ? n = !0 : oe = [], pt++;
  try {
    const r = e();
    return Wr(n), r;
  } catch (r) {
    n || (oe = null), K = null, Zn(r);
  }
}
function Wr(e) {
  if (K && (Yn(K), K = null), e)
    return;
  const t = oe;
  oe = null, t.length && Ae(() => Wn(t), !1);
}
function Yn(e) {
  for (let t = 0; t < e.length; t++)
    tt(e[t]);
}
function Vr(e) {
  let t, n = 0;
  for (t = 0; t < e.length; t++) {
    const r = e[t];
    r.user ? e[n++] = r : tt(r);
  }
  for (t = 0; t < n; t++)
    tt(e[t]);
}
function nt(e, t) {
  e.state = 0;
  for (let n = 0; n < e.sources.length; n += 1) {
    const r = e.sources[n];
    if (r.sources) {
      const i = r.state;
      i === ue ? r !== t && (!r.updatedAt || r.updatedAt < pt) && tt(r) : i === Qe && nt(r, t);
    }
  }
}
function Hn(e) {
  for (let t = 0; t < e.observers.length; t += 1) {
    const n = e.observers[t];
    n.state || (n.state = Qe, n.pure ? K.push(n) : oe.push(n), n.observers && Hn(n));
  }
}
function yt(e) {
  let t;
  if (e.sources)
    for (; e.sources.length; ) {
      const n = e.sources.pop(), r = e.sourceSlots.pop(), i = n.observers;
      if (i && i.length) {
        const o = i.pop(), s = n.observerSlots.pop();
        r < i.length && (o.sourceSlots[s] = r, i[r] = o, n.observerSlots[r] = s);
      }
    }
  if (e.owned) {
    for (t = e.owned.length - 1; t >= 0; t--)
      yt(e.owned[t]);
    e.owned = null;
  }
  if (e.cleanups) {
    for (t = e.cleanups.length - 1; t >= 0; t--)
      e.cleanups[t]();
    e.cleanups = null;
  }
  e.state = 0;
}
function Ur(e) {
  return e instanceof Error ? e : new Error(typeof e == "string" ? e : "Unknown error", {
    cause: e
  });
}
function Zn(e, t = L) {
  throw Ur(e);
}
function Mt(e) {
  if (typeof e == "function" && !e.length)
    return Mt(e());
  if (Array.isArray(e)) {
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const r = Mt(e[n]);
      Array.isArray(r) ? t.push.apply(t, r) : t.push(r);
    }
    return t;
  }
  return e;
}
function Gr(e, t) {
  return function(r) {
    let i;
    return Y(
      () => i = U(() => (L.context = {
        ...L.context,
        [e]: r.value
      }, Gn(() => r.children))),
      void 0
    ), i;
  };
}
const qr = Symbol("fallback");
function dn(e) {
  for (let t = 0; t < e.length; t++)
    e[t]();
}
function Xr(e, t, n = {}) {
  let r = [], i = [], o = [], s = 0, a = t.length > 1 ? [] : null;
  return gt(() => dn(o)), () => {
    let f = e() || [], l, c;
    return f[jt], U(() => {
      let d = f.length, h, g, p, P, w, N, $, I, z;
      if (d === 0)
        s !== 0 && (dn(o), o = [], r = [], i = [], s = 0, a && (a = [])), n.fallback && (r = [qr], i[0] = Ye((ne) => (o[0] = ne, n.fallback())), s = 1);
      else if (s === 0) {
        for (i = new Array(d), c = 0; c < d; c++)
          r[c] = f[c], i[c] = Ye(u);
        s = d;
      } else {
        for (p = new Array(d), P = new Array(d), a && (w = new Array(d)), N = 0, $ = Math.min(s, d); N < $ && r[N] === f[N]; N++)
          ;
        for ($ = s - 1, I = d - 1; $ >= N && I >= N && r[$] === f[I]; $--, I--)
          p[I] = i[$], P[I] = o[$], a && (w[I] = a[$]);
        for (h = /* @__PURE__ */ new Map(), g = new Array(I + 1), c = I; c >= N; c--)
          z = f[c], l = h.get(z), g[c] = l === void 0 ? -1 : l, h.set(z, c);
        for (l = N; l <= $; l++)
          z = r[l], c = h.get(z), c !== void 0 && c !== -1 ? (p[c] = i[l], P[c] = o[l], a && (w[c] = a[l]), c = g[c], h.set(z, c)) : o[l]();
        for (c = N; c < d; c++)
          c in p ? (i[c] = p[c], o[c] = P[c], a && (a[c] = w[c], a[c](c))) : i[c] = Ye(u);
        i = i.slice(0, s = d), r = f.slice(0);
      }
      return i;
    });
    function u(d) {
      if (o[c] = d, a) {
        const [h, g] = X(c);
        return a[c] = g, t(f[c], h);
      }
      return t(f[c]);
    }
  };
}
function O(e, t) {
  return U(() => e(t || {}));
}
function Ue() {
  return !0;
}
const Bt = {
  get(e, t, n) {
    return t === H ? n : e.get(t);
  },
  has(e, t) {
    return t === H ? !0 : e.has(t);
  },
  set: Ue,
  deleteProperty: Ue,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: Ue,
      deleteProperty: Ue
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function Ot(e) {
  return (e = typeof e == "function" ? e() : e) ? e : {};
}
function Yr() {
  for (let e = 0, t = this.length; e < t; ++e) {
    const n = this[e]();
    if (n !== void 0)
      return n;
  }
}
function tn(...e) {
  let t = !1;
  for (let s = 0; s < e.length; s++) {
    const a = e[s];
    t = t || !!a && H in a, e[s] = typeof a == "function" ? (t = !0, V(a)) : a;
  }
  if (t)
    return new Proxy(
      {
        get(s) {
          for (let a = e.length - 1; a >= 0; a--) {
            const f = Ot(e[a])[s];
            if (f !== void 0)
              return f;
          }
        },
        has(s) {
          for (let a = e.length - 1; a >= 0; a--)
            if (s in Ot(e[a]))
              return !0;
          return !1;
        },
        keys() {
          const s = [];
          for (let a = 0; a < e.length; a++)
            s.push(...Object.keys(Ot(e[a])));
          return [...new Set(s)];
        }
      },
      Bt
    );
  const n = {}, r = /* @__PURE__ */ Object.create(null);
  for (let s = e.length - 1; s >= 0; s--) {
    const a = e[s];
    if (!a)
      continue;
    const f = Object.getOwnPropertyNames(a);
    for (let l = f.length - 1; l >= 0; l--) {
      const c = f[l];
      if (c === "__proto__" || c === "constructor")
        continue;
      const u = Object.getOwnPropertyDescriptor(a, c);
      if (!r[c])
        r[c] = u.get ? {
          enumerable: !0,
          configurable: !0,
          get: Yr.bind(n[c] = [u.get.bind(a)])
        } : u.value !== void 0 ? u : void 0;
      else {
        const d = n[c];
        d && (u.get ? d.push(u.get.bind(a)) : u.value !== void 0 && d.push(() => u.value));
      }
    }
  }
  const i = {}, o = Object.keys(r);
  for (let s = o.length - 1; s >= 0; s--) {
    const a = o[s], f = r[a];
    f && f.get ? Object.defineProperty(i, a, f) : i[a] = f ? f.value : void 0;
  }
  return i;
}
function nn(e, ...t) {
  if (H in e) {
    const i = new Set(t.length > 1 ? t.flat() : t[0]), o = t.map((s) => new Proxy(
      {
        get(a) {
          return s.includes(a) ? e[a] : void 0;
        },
        has(a) {
          return s.includes(a) && a in e;
        },
        keys() {
          return s.filter((a) => a in e);
        }
      },
      Bt
    ));
    return o.push(
      new Proxy(
        {
          get(s) {
            return i.has(s) ? void 0 : e[s];
          },
          has(s) {
            return i.has(s) ? !1 : s in e;
          },
          keys() {
            return Object.keys(e).filter((s) => !i.has(s));
          }
        },
        Bt
      )
    ), o;
  }
  const n = {}, r = t.map(() => ({}));
  for (const i of Object.getOwnPropertyNames(e)) {
    const o = Object.getOwnPropertyDescriptor(e, i), s = !o.get && !o.set && o.enumerable && o.writable && o.configurable;
    let a = !1, f = 0;
    for (const l of t)
      l.includes(i) && (a = !0, s ? r[f][i] = o.value : Object.defineProperty(r[f], i, o)), ++f;
    a || (s ? n[i] = o.value : Object.defineProperty(n, i, o));
  }
  return [...r, n];
}
let Hr = 0;
function Zr() {
  return `cl-${Hr++}`;
}
const Jn = (e) => `Stale read from <${e}>.`;
function Jr(e) {
  const t = "fallback" in e && {
    fallback: () => e.fallback
  };
  return V(Xr(() => e.each, e.children, t || void 0));
}
function Pe(e) {
  const t = e.keyed, n = V(() => e.when, void 0, {
    equals: (r, i) => t ? r === i : !r == !i
  });
  return V(
    () => {
      const r = n();
      if (r) {
        const i = e.children;
        return typeof i == "function" && i.length > 0 ? U(
          () => i(
            t ? r : () => {
              if (!U(n))
                throw Jn("Show");
              return e.when;
            }
          )
        ) : i;
      }
      return e.fallback;
    },
    void 0,
    void 0
  );
}
function Qr(e) {
  let t = !1;
  const n = (o, s) => (t ? o[1] === s[1] : !o[1] == !s[1]) && o[2] === s[2], r = Gn(() => e.children), i = V(
    () => {
      let o = r();
      Array.isArray(o) || (o = [o]);
      for (let s = 0; s < o.length; s++) {
        const a = o[s].when;
        if (a)
          return t = !!o[s].keyed, [s, a, o[s]];
      }
      return [-1];
    },
    void 0,
    {
      equals: n
    }
  );
  return V(
    () => {
      const [o, s, a] = i();
      if (o < 0)
        return e.fallback;
      const f = a.children;
      return typeof f == "function" && f.length > 0 ? U(
        () => f(
          t ? s : () => {
            if (U(i)[0] !== o)
              throw Jn("Match");
            return a.when;
          }
        )
      ) : f;
    },
    void 0,
    void 0
  );
}
function xt(e) {
  return e;
}
const ei = [
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "disabled",
  "formnovalidate",
  "hidden",
  "indeterminate",
  "inert",
  "ismap",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "seamless",
  "selected"
], ti = /* @__PURE__ */ new Set([
  "className",
  "value",
  "readOnly",
  "formNoValidate",
  "isMap",
  "noModule",
  "playsInline",
  ...ei
]), ni = /* @__PURE__ */ new Set([
  "innerHTML",
  "textContent",
  "innerText",
  "children"
]), ri = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  className: "class",
  htmlFor: "for"
}), ii = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
  class: "className",
  formnovalidate: {
    $: "formNoValidate",
    BUTTON: 1,
    INPUT: 1
  },
  ismap: {
    $: "isMap",
    IMG: 1
  },
  nomodule: {
    $: "noModule",
    SCRIPT: 1
  },
  playsinline: {
    $: "playsInline",
    VIDEO: 1
  },
  readonly: {
    $: "readOnly",
    INPUT: 1,
    TEXTAREA: 1
  }
});
function oi(e, t) {
  const n = ii[e];
  return typeof n == "object" ? n[t] ? n.$ : void 0 : n;
}
const si = /* @__PURE__ */ new Set([
  "beforeinput",
  "click",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
]), ai = /* @__PURE__ */ new Set([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animate",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "circle",
  "clipPath",
  "color-profile",
  "cursor",
  "defs",
  "desc",
  "ellipse",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "filter",
  "font",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignObject",
  "g",
  "glyph",
  "glyphRef",
  "hkern",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "metadata",
  "missing-glyph",
  "mpath",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "set",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "textPath",
  "tref",
  "tspan",
  "use",
  "view",
  "vkern"
]), li = {
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace"
};
function ci(e, t, n) {
  let r = n.length, i = t.length, o = r, s = 0, a = 0, f = t[i - 1].nextSibling, l = null;
  for (; s < i || a < o; ) {
    if (t[s] === n[a]) {
      s++, a++;
      continue;
    }
    for (; t[i - 1] === n[o - 1]; )
      i--, o--;
    if (i === s) {
      const c = o < r ? a ? n[a - 1].nextSibling : n[o - a] : f;
      for (; a < o; )
        e.insertBefore(n[a++], c);
    } else if (o === a)
      for (; s < i; )
        (!l || !l.has(t[s])) && t[s].remove(), s++;
    else if (t[s] === n[o - 1] && n[a] === t[i - 1]) {
      const c = t[--i].nextSibling;
      e.insertBefore(n[a++], t[s++].nextSibling), e.insertBefore(n[--o], c), t[i] = n[o];
    } else {
      if (!l) {
        l = /* @__PURE__ */ new Map();
        let u = a;
        for (; u < o; )
          l.set(n[u], u++);
      }
      const c = l.get(t[s]);
      if (c != null)
        if (a < c && c < o) {
          let u = s, d = 1, h;
          for (; ++u < i && u < o && !((h = l.get(t[u])) == null || h !== c + d); )
            d++;
          if (d > c - a) {
            const g = t[s];
            for (; a < c; )
              e.insertBefore(n[a++], g);
          } else
            e.replaceChild(n[a++], t[s++]);
        } else
          s++;
      else
        t[s++].remove();
    }
  }
}
const fn = "_$DX_DELEGATE";
function M(e, t, n) {
  let r;
  const i = () => {
    const s = document.createElement("template");
    return s.innerHTML = e, n ? s.content.firstChild.firstChild : s.content.firstChild;
  }, o = t ? () => U(() => document.importNode(r || (r = i()), !0)) : () => (r || (r = i())).cloneNode(!0);
  return o.cloneNode = o, o;
}
function vt(e, t = window.document) {
  const n = t[fn] || (t[fn] = /* @__PURE__ */ new Set());
  for (let r = 0, i = e.length; r < i; r++) {
    const o = e[r];
    n.has(o) || (n.add(o), t.addEventListener(o, gi));
  }
}
function ee(e, t, n) {
  n == null ? e.removeAttribute(t) : e.setAttribute(t, n);
}
function ui(e, t, n, r) {
  r == null ? e.removeAttributeNS(t, n) : e.setAttributeNS(t, n, r);
}
function di(e, t) {
  t == null ? e.removeAttribute("class") : e.className = t;
}
function Qn(e, t, n, r) {
  if (r)
    Array.isArray(n) ? (e[`$$${t}`] = n[0], e[`$$${t}Data`] = n[1]) : e[`$$${t}`] = n;
  else if (Array.isArray(n)) {
    const i = n[0];
    e.addEventListener(t, n[0] = (o) => i.call(e, n[1], o));
  } else
    e.addEventListener(t, n);
}
function fi(e, t, n = {}) {
  const r = Object.keys(t || {}), i = Object.keys(n);
  let o, s;
  for (o = 0, s = i.length; o < s; o++) {
    const a = i[o];
    !a || a === "undefined" || t[a] || (pn(e, a, !1), delete n[a]);
  }
  for (o = 0, s = r.length; o < s; o++) {
    const a = r[o], f = !!t[a];
    !a || a === "undefined" || n[a] === f || !f || (pn(e, a, !0), n[a] = f);
  }
  return n;
}
function te(e, t, n) {
  if (!t)
    return n ? ee(e, "style") : t;
  const r = e.style;
  if (typeof t == "string")
    return r.cssText = t;
  typeof n == "string" && (r.cssText = n = void 0), n || (n = {}), t || (t = {});
  let i, o;
  for (o in n)
    t[o] == null && r.removeProperty(o), delete n[o];
  for (o in t)
    i = t[o], i !== n[o] && (r.setProperty(o, i), n[o] = i);
  return n;
}
function er(e, t = {}, n, r) {
  const i = {};
  return r || Y(
    () => i.children = Ce(e, t.children, i.children)
  ), Y(() => t.ref && t.ref(e)), Y(() => hi(e, t, n, !0, i, !0)), i;
}
function hn(e, t, n) {
  return U(() => e(t, n));
}
function _(e, t, n, r) {
  if (n !== void 0 && !r && (r = []), typeof t != "function")
    return Ce(e, t, r, n);
  Y((i) => Ce(e, t(), i, n), r);
}
function hi(e, t, n, r, i = {}, o = !1) {
  t || (t = {});
  for (const s in i)
    if (!(s in t)) {
      if (s === "children")
        continue;
      i[s] = gn(e, s, null, i[s], n, o);
    }
  for (const s in t) {
    if (s === "children") {
      r || Ce(e, t.children);
      continue;
    }
    const a = t[s];
    i[s] = gn(e, s, a, i[s], n, o);
  }
}
function pi(e) {
  return e.toLowerCase().replace(/-([a-z])/g, (t, n) => n.toUpperCase());
}
function pn(e, t, n) {
  const r = t.trim().split(/\s+/);
  for (let i = 0, o = r.length; i < o; i++)
    e.classList.toggle(r[i], n);
}
function gn(e, t, n, r, i, o) {
  let s, a, f, l, c;
  if (t === "style")
    return te(e, n, r);
  if (t === "classList")
    return fi(e, n, r);
  if (n === r)
    return r;
  if (t === "ref")
    o || n(e);
  else if (t.slice(0, 3) === "on:") {
    const u = t.slice(3);
    r && e.removeEventListener(u, r), n && e.addEventListener(u, n);
  } else if (t.slice(0, 10) === "oncapture:") {
    const u = t.slice(10);
    r && e.removeEventListener(u, r, !0), n && e.addEventListener(u, n, !0);
  } else if (t.slice(0, 2) === "on") {
    const u = t.slice(2).toLowerCase(), d = si.has(u);
    if (!d && r) {
      const h = Array.isArray(r) ? r[0] : r;
      e.removeEventListener(u, h);
    }
    (d || n) && (Qn(e, u, n, d), d && vt([u]));
  } else if (t.slice(0, 5) === "attr:")
    ee(e, t.slice(5), n);
  else if ((c = t.slice(0, 5) === "prop:") || (f = ni.has(t)) || !i && ((l = oi(t, e.tagName)) || (a = ti.has(t))) || (s = e.nodeName.includes("-")))
    c && (t = t.slice(5), a = !0), t === "class" || t === "className" ? di(e, n) : s && !a && !f ? e[pi(t)] = n : e[l || t] = n;
  else {
    const u = i && t.indexOf(":") > -1 && li[t.split(":")[0]];
    u ? ui(e, u, t, n) : ee(e, ri[t] || t, n);
  }
  return n;
}
function gi(e) {
  const t = `$$${e.type}`;
  let n = e.composedPath && e.composedPath()[0] || e.target;
  for (e.target !== n && Object.defineProperty(e, "target", {
    configurable: !0,
    value: n
  }), Object.defineProperty(e, "currentTarget", {
    configurable: !0,
    get() {
      return n || document;
    }
  }); n; ) {
    const r = n[t];
    if (r && !n.disabled) {
      const i = n[`${t}Data`];
      if (i !== void 0 ? r.call(n, i, e) : r.call(n, e), e.cancelBubble)
        return;
    }
    n = n._$host || n.parentNode || n.host;
  }
}
function Ce(e, t, n, r, i) {
  for (; typeof n == "function"; )
    n = n();
  if (t === n)
    return n;
  const o = typeof t, s = r !== void 0;
  if (e = s && n[0] && n[0].parentNode || e, o === "string" || o === "number")
    if (o === "number" && (t = t.toString()), s) {
      let a = n[0];
      a && a.nodeType === 3 ? a.data !== t && (a.data = t) : a = document.createTextNode(t), n = ye(e, n, r, a);
    } else
      n !== "" && typeof n == "string" ? n = e.firstChild.data = t : n = e.textContent = t;
  else if (t == null || o === "boolean")
    n = ye(e, n, r);
  else {
    if (o === "function")
      return Y(() => {
        let a = t();
        for (; typeof a == "function"; )
          a = a();
        n = Ce(e, a, n, r);
      }), () => n;
    if (Array.isArray(t)) {
      const a = [], f = n && Array.isArray(n);
      if (Kt(a, t, n, i))
        return Y(() => n = Ce(e, a, n, r, !0)), () => n;
      if (a.length === 0) {
        if (n = ye(e, n, r), s)
          return n;
      } else
        f ? n.length === 0 ? yn(e, a, r) : ci(e, n, a) : (n && ye(e), yn(e, a));
      n = a;
    } else if (t.nodeType) {
      if (Array.isArray(n)) {
        if (s)
          return n = ye(e, n, r, t);
        ye(e, n, null, t);
      } else
        n == null || n === "" || !e.firstChild ? e.appendChild(t) : e.replaceChild(t, e.firstChild);
      n = t;
    }
  }
  return n;
}
function Kt(e, t, n, r) {
  let i = !1;
  for (let o = 0, s = t.length; o < s; o++) {
    let a = t[o], f = n && n[e.length], l;
    if (!(a == null || a === !0 || a === !1))
      if ((l = typeof a) == "object" && a.nodeType)
        e.push(a);
      else if (Array.isArray(a))
        i = Kt(e, a, f) || i;
      else if (l === "function")
        if (r) {
          for (; typeof a == "function"; )
            a = a();
          i = Kt(
            e,
            Array.isArray(a) ? a : [a],
            Array.isArray(f) ? f : [f]
          ) || i;
        } else
          e.push(a), i = !0;
      else {
        const c = String(a);
        f && f.nodeType === 3 && f.data === c ? e.push(f) : e.push(document.createTextNode(c));
      }
  }
  return i;
}
function yn(e, t, n = null) {
  for (let r = 0, i = t.length; r < i; r++)
    e.insertBefore(t[r], n);
}
function ye(e, t, n, r) {
  if (n === void 0)
    return e.textContent = "";
  const i = r || document.createTextNode("");
  if (t.length) {
    let o = !1;
    for (let s = t.length - 1; s >= 0; s--) {
      const a = t[s];
      if (i !== a) {
        const f = a.parentNode === e;
        !o && !s ? f ? e.replaceChild(i, a) : e.insertBefore(i, n) : f && a.remove();
      } else
        o = !0;
    }
  } else
    e.insertBefore(i, n);
  return [i];
}
const yi = "http://www.w3.org/2000/svg";
function vi(e, t = !1) {
  return t ? document.createElementNS(yi, e) : document.createElement(e);
}
function bi(e) {
  const [t, n] = nn(e, ["component"]), r = V(() => t.component);
  return V(() => {
    const i = r();
    switch (typeof i) {
      case "function":
        return U(() => i(n));
      case "string":
        const o = ai.has(i), s = vi(i, o);
        return er(s, n, o), s;
    }
  });
}
function mi(e) {
  const t = Object.keys(e), n = {};
  for (let r = 0; r < t.length; r++) {
    const [i, o] = X(e[t[r]]);
    Object.defineProperty(n, t[r], {
      get: i,
      set(s) {
        o(() => s);
      }
    });
  }
  return n;
}
function wi(e) {
  if (e.assignedSlot && e.assignedSlot._$owner)
    return e.assignedSlot._$owner;
  let t = e.parentNode;
  for (; t && !t._$owner && !(t.assignedSlot && t.assignedSlot._$owner); )
    t = t.parentNode;
  return t && t.assignedSlot ? t.assignedSlot._$owner : e._$owner;
}
function Ei(e) {
  return (t, n) => {
    const { element: r } = n;
    return Ye((i) => {
      const o = mi(t);
      r.addPropertyChangedCallback((a, f) => o[a] = f), r.addReleaseCallback(() => {
        r.renderRoot.textContent = "", i();
      });
      const s = e(o, n);
      return _(r.renderRoot, s);
    }, wi(r));
  };
}
function Pi(e, t, n) {
  return arguments.length === 2 && (n = t, t = {}), jr(e, t)(Ei(n));
}
function Si(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function bt(e = {}) {
  const { strict: t = !0, hookName: n = "useContext", providerName: r = "Provider", errorMessage: i } = e, o = Br(void 0);
  function s() {
    var f;
    const a = Kr(o);
    if (!a && t) {
      const l = new Error(i ?? Si(n, r));
      throw l.name = "ContextError", (f = Error.captureStackTrace) == null || f.call(Error, l, s), l;
    }
    return a;
  }
  return [o.Provider, s, o];
}
function Ci(e) {
  return new Proxy({}, {
    get() {
      return e;
    }
  });
}
var tr = () => (e) => Array.from(new Set(e)), Oi = /[A-Z]/g, xi = /^ms-/, At = {};
function Ai(e) {
  return "-" + e.toLowerCase();
}
function Ni(e) {
  if (At.hasOwnProperty(e))
    return At[e];
  var t = e.replace(Oi, Ai);
  return At[e] = xi.test(t) ? "-" + t : t;
}
const zt = Symbol("store-raw"), Se = Symbol("store-node"), re = Symbol("store-has"), nr = Symbol("store-self");
function rr(e) {
  let t = e[H];
  if (!t && (Object.defineProperty(e, H, {
    value: t = new Proxy(e, Di)
  }), !Array.isArray(e))) {
    const n = Object.keys(e), r = Object.getOwnPropertyDescriptors(e);
    for (let i = 0, o = n.length; i < o; i++) {
      const s = n[i];
      r[s].get && Object.defineProperty(e, s, {
        enumerable: r[s].enumerable,
        get: r[s].get.bind(t)
      });
    }
  }
  return t;
}
function le(e) {
  let t;
  return e != null && typeof e == "object" && (e[H] || !(t = Object.getPrototypeOf(e)) || t === Object.prototype || Array.isArray(e));
}
function Oe(e, t = /* @__PURE__ */ new Set()) {
  let n, r, i, o;
  if (n = e != null && e[zt])
    return n;
  if (!le(e) || t.has(e))
    return e;
  if (Array.isArray(e)) {
    Object.isFrozen(e) ? e = e.slice(0) : t.add(e);
    for (let s = 0, a = e.length; s < a; s++)
      i = e[s], (r = Oe(i, t)) !== i && (e[s] = r);
  } else {
    Object.isFrozen(e) ? e = Object.assign({}, e) : t.add(e);
    const s = Object.keys(e), a = Object.getOwnPropertyDescriptors(e);
    for (let f = 0, l = s.length; f < l; f++)
      o = s[f], !a[o].get && (i = e[o], (r = Oe(i, t)) !== i && (e[o] = r));
  }
  return e;
}
function rt(e, t) {
  let n = e[t];
  return n || Object.defineProperty(e, t, {
    value: n = /* @__PURE__ */ Object.create(null)
  }), n;
}
function Re(e, t, n) {
  if (e[t])
    return e[t];
  const [r, i] = X(n, {
    equals: !1,
    internal: !0
  });
  return r.$ = i, e[t] = r;
}
function Ti(e, t) {
  const n = Reflect.getOwnPropertyDescriptor(e, t);
  return !n || n.get || !n.configurable || t === H || t === Se || (delete n.value, delete n.writable, n.get = () => e[H][t]), n;
}
function ir(e) {
  Rt() && Re(rt(e, Se), nr)();
}
function ki(e) {
  return ir(e), Reflect.ownKeys(e);
}
const Di = {
  get(e, t, n) {
    if (t === zt)
      return e;
    if (t === H)
      return n;
    if (t === jt)
      return ir(e), n;
    const r = rt(e, Se), i = r[t];
    let o = i ? i() : e[t];
    if (t === Se || t === re || t === "__proto__")
      return o;
    if (!i) {
      const s = Object.getOwnPropertyDescriptor(e, t);
      Rt() && (typeof o != "function" || e.hasOwnProperty(t)) && !(s && s.get) && (o = Re(r, t, o)());
    }
    return le(o) ? rr(o) : o;
  },
  has(e, t) {
    return t === zt || t === H || t === jt || t === Se || t === re || t === "__proto__" ? !0 : (Rt() && Re(rt(e, re), t)(), t in e);
  },
  set() {
    return !0;
  },
  deleteProperty() {
    return !0;
  },
  ownKeys: ki,
  getOwnPropertyDescriptor: Ti
};
function q(e, t, n, r = !1) {
  if (!r && e[t] === n)
    return;
  const i = e[t], o = e.length;
  n === void 0 ? (delete e[t], e[re] && e[re][t] && i !== void 0 && e[re][t].$()) : (e[t] = n, e[re] && e[re][t] && i === void 0 && e[re][t].$());
  let s = rt(e, Se), a;
  if ((a = Re(s, t, i)) && a.$(() => n), Array.isArray(e) && e.length !== o) {
    for (let f = e.length; f < o; f++)
      (a = s[f]) && a.$();
    (a = Re(s, "length", o)) && a.$(e.length);
  }
  (a = s[nr]) && a.$();
}
function or(e, t) {
  const n = Object.keys(t);
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    q(e, i, t[i]);
  }
}
function Li(e, t) {
  if (typeof t == "function" && (t = t(e)), t = Oe(t), Array.isArray(t)) {
    if (e === t)
      return;
    let n = 0, r = t.length;
    for (; n < r; n++) {
      const i = t[n];
      e[n] !== i && q(e, n, i);
    }
    q(e, "length", r);
  } else
    or(e, t);
}
function Fe(e, t, n = []) {
  let r, i = e;
  if (t.length > 1) {
    r = t.shift();
    const s = typeof r, a = Array.isArray(e);
    if (Array.isArray(r)) {
      for (let f = 0; f < r.length; f++)
        Fe(e, [r[f]].concat(t), n);
      return;
    } else if (a && s === "function") {
      for (let f = 0; f < e.length; f++)
        r(e[f], f) && Fe(e, [f].concat(t), n);
      return;
    } else if (a && s === "object") {
      const { from: f = 0, to: l = e.length - 1, by: c = 1 } = r;
      for (let u = f; u <= l; u += c)
        Fe(e, [u].concat(t), n);
      return;
    } else if (t.length > 1) {
      Fe(e[r], t, [r].concat(n));
      return;
    }
    i = e[r], n = [r].concat(n);
  }
  let o = t[0];
  typeof o == "function" && (o = o(i, n), o === i) || r === void 0 && o == null || (o = Oe(o), r === void 0 || le(i) && le(o) && !Array.isArray(o) ? or(i, o) : q(e, r, o));
}
function $i(...[e, t]) {
  const n = Oe(e || {}), r = Array.isArray(n), i = rr(n);
  function o(...s) {
    Un(() => {
      r && s.length === 1 ? Li(n, s[0]) : Fe(n, s);
    });
  }
  return [i, o];
}
const Wt = Symbol("store-root");
function me(e, t, n, r, i) {
  const o = t[n];
  if (e === o)
    return;
  const s = Array.isArray(e);
  if (n !== Wt && (!le(e) || !le(o) || s !== Array.isArray(o) || i && e[i] !== o[i])) {
    q(t, n, e);
    return;
  }
  if (s) {
    if (e.length && o.length && (!r || i && e[0] && e[0][i] != null)) {
      let l, c, u, d, h, g, p, P;
      for (u = 0, d = Math.min(o.length, e.length); u < d && (o[u] === e[u] || i && o[u] && e[u] && o[u][i] === e[u][i]); u++)
        me(e[u], o, u, r, i);
      const w = new Array(e.length), N = /* @__PURE__ */ new Map();
      for (d = o.length - 1, h = e.length - 1; d >= u && h >= u && (o[d] === e[h] || i && o[u] && e[u] && o[d][i] === e[h][i]); d--, h--)
        w[h] = o[d];
      if (u > h || u > d) {
        for (c = u; c <= h; c++)
          q(o, c, e[c]);
        for (; c < e.length; c++)
          q(o, c, w[c]), me(e[c], o, c, r, i);
        o.length > e.length && q(o, "length", e.length);
        return;
      }
      for (p = new Array(h + 1), c = h; c >= u; c--)
        g = e[c], P = i && g ? g[i] : g, l = N.get(P), p[c] = l === void 0 ? -1 : l, N.set(P, c);
      for (l = u; l <= d; l++)
        g = o[l], P = i && g ? g[i] : g, c = N.get(P), c !== void 0 && c !== -1 && (w[c] = o[l], c = p[c], N.set(P, c));
      for (c = u; c < e.length; c++)
        c in w ? (q(o, c, w[c]), me(e[c], o, c, r, i)) : q(o, c, e[c]);
    } else
      for (let l = 0, c = e.length; l < c; l++)
        me(e[l], o, l, r, i);
    o.length > e.length && q(o, "length", e.length);
    return;
  }
  const a = Object.keys(e);
  for (let l = 0, c = a.length; l < c; l++)
    me(e[a[l]], o, a[l], r, i);
  const f = Object.keys(o);
  for (let l = 0, c = f.length; l < c; l++)
    e[f[l]] === void 0 && q(o, f[l], void 0);
}
function Fi(e, t = {}) {
  const { merge: n, key: r = "id" } = t, i = Oe(e);
  return (o) => {
    if (!le(o) || !le(i))
      return i;
    const s = me(
      i,
      {
        [Wt]: o
      },
      Wt,
      n,
      r
    );
    return s === void 0 ? o : s;
  };
}
function Ge() {
  return !0;
}
var _i = {
  get(e, t, n) {
    return t === H ? n : e.get(t);
  },
  has(e, t) {
    return e.has(t);
  },
  set: Ge,
  deleteProperty: Ge,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: Ge,
      deleteProperty: Ge
    };
  },
  ownKeys(e) {
    return e.keys();
  }
}, Vt = (e) => typeof e == "function" && !e.length ? e() : e;
function vn(e) {
  return (...t) => {
    for (const n of e)
      n && n(...t);
  };
}
var Ii = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g;
function bn(e) {
  const t = {};
  let n;
  for (; n = Ii.exec(e); )
    t[n[1]] = n[2];
  return t;
}
function ji(e, t) {
  if (typeof e == "object" && typeof t == "object")
    return { ...e, ...t };
  if (typeof e == "string" && typeof t == "string")
    return `${e};${t}`;
  const n = typeof e == "object" ? e : bn(e), r = typeof t == "object" ? t : bn(t);
  return { ...n, ...r };
}
var Nt = (e, t, n) => {
  let r;
  for (const i of e) {
    const o = Vt(i)[t];
    r ? o && (r = n(r, o)) : r = o;
  }
  return r;
};
function ce(...e) {
  if (e.length === 1)
    return e[0];
  const t = {};
  for (const r of e) {
    const i = Vt(r);
    for (const o in i)
      if (o[0] === "o" && o[1] === "n" && o[2]) {
        const s = i[o], a = o.toLowerCase(), f = typeof s == "function" ? s : (
          // jsx event handlers can be tuples of [callback, arg]
          Array.isArray(s) ? s.length === 1 ? s[0] : s[0].bind(void 0, s[1]) : void 0
        );
        f ? t[a] ? t[a].push(f) : t[a] = [f] : delete t[a];
      }
  }
  const n = tn(...e);
  return new Proxy(
    {
      get(r) {
        if (typeof r != "string")
          return Reflect.get(n, r);
        if (r === "style")
          return Nt(e, "style", ji);
        if (r === "ref") {
          const i = [];
          for (const o of e) {
            const s = Vt(o)[r];
            typeof s == "function" && i.push(s);
          }
          return vn(i);
        }
        if (r[0] === "o" && r[1] === "n" && r[2]) {
          const i = t[r.toLowerCase()];
          return i ? vn(i) : Reflect.get(n, r);
        }
        return r === "class" || r === "className" ? Nt(e, r, (i, o) => `${i} ${o}`) : r === "classList" ? Nt(e, r, (i, o) => ({ ...i, ...o })) : Reflect.get(n, r);
      },
      has(r) {
        return Reflect.has(n, r);
      },
      keys() {
        return Object.keys(n);
      }
    },
    _i
  );
}
var Ri = (e) => Array.isArray(e), Mi = (e) => !(e == null || typeof e != "object" || Ri(e)), Bi = (e) => typeof e == "number" && !Number.isNaN(e), sr = (e) => typeof e == "string", Ki = (e) => e.startsWith("--") ? e : Ni(e);
function zi(e) {
  let t = {};
  for (const n in e) {
    const r = e[n];
    !sr(r) && !Bi(r) || (t[Ki(n)] = r);
  }
  return t;
}
var mn = {
  onFocus: "onFocusIn",
  onBlur: "onFocusOut",
  onDoubleClick: "onDblClick",
  onChange: "onInput",
  defaultChecked: "checked",
  defaultValue: "value",
  htmlFor: "for",
  className: "class"
};
function Wi(e) {
  return e in mn ? mn[e] : e;
}
var Vi = Ci((e) => {
  const t = {};
  for (const n in e) {
    const r = e[n];
    if (n === "style" && Mi(r)) {
      t.style = zi(r);
      continue;
    }
    if (n === "children") {
      sr(r) && (t.textContent = r);
      continue;
    }
    t[Wi(n)] = r;
  }
  return t;
});
function Ui(e, t) {
  const { actions: n, context: r } = t ?? {}, [i, o] = $i(e.getState());
  return Qt(() => {
    const s = e.subscribe((a) => {
      o(Fi(a));
    });
    gt(() => {
      s();
    });
  }), et(() => {
    const s = typeof r == "function" ? r() : r;
    e.setContext(s);
  }), et(() => {
    e.setOptions({ actions: n });
  }), i;
}
function Gi(e, t) {
  const { state: n, context: r } = t ?? {}, i = (() => {
    const o = typeof e == "function" ? e() : e, s = typeof r == "function" ? r() : r;
    return s && o.setContext(s), o;
  })();
  return Qt(() => {
    i.start(n), gt(() => {
      i.stop();
    });
  }), i;
}
function ar(e, t) {
  const n = Gi(e, t);
  return [Ui(n, t), n.send, n];
}
const rn = () => (e, t) => nn(e, t), Tt = (e) => (n) => {
  const [r, i] = nn(n, ["as"]);
  return O(bi, tn({
    get component() {
      return r.as || e;
    }
  }, i));
};
function qi() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Tt, {
    apply(t, n, r) {
      return Tt(r[0]);
    },
    get(t, n) {
      const r = n;
      return e.has(r) || e.set(r, Tt(r)), e.get(r);
    }
  });
}
const We = qi(), Xi = (e) => rn()(e, [
  "lazyMount",
  "onExitComplete",
  "present",
  "unmountOnExit"
]), Yi = Symbol(), wn = Object.getPrototypeOf, Ut = /* @__PURE__ */ new WeakMap(), Hi = (e) => e && (Ut.has(e) ? Ut.get(e) : wn(e) === Object.prototype || wn(e) === Array.prototype), Zi = (e) => Hi(e) && e[Yi] || null, En = (e, t = !0) => {
  Ut.set(e, t);
};
var it = process.env.NODE_ENV !== "production", kt = (e) => typeof e == "object" && e !== null, he = /* @__PURE__ */ new WeakMap(), _e = /* @__PURE__ */ new WeakSet(), Ji = (e = Object.is, t = (l, c) => new Proxy(l, c), n = (l) => kt(l) && !_e.has(l) && (Array.isArray(l) || !(Symbol.iterator in l)) && !(l instanceof WeakMap) && !(l instanceof WeakSet) && !(l instanceof Error) && !(l instanceof Number) && !(l instanceof Date) && !(l instanceof String) && !(l instanceof RegExp) && !(l instanceof ArrayBuffer), r = (l) => {
  switch (l.status) {
    case "fulfilled":
      return l.value;
    case "rejected":
      throw l.reason;
    default:
      throw l;
  }
}, i = /* @__PURE__ */ new WeakMap(), o = (l, c, u = r) => {
  const d = i.get(l);
  if ((d == null ? void 0 : d[0]) === c)
    return d[1];
  const h = Array.isArray(l) ? [] : Object.create(Object.getPrototypeOf(l));
  return En(h, !0), i.set(l, [c, h]), Reflect.ownKeys(l).forEach((g) => {
    const p = Reflect.get(l, g);
    _e.has(p) ? (En(p, !1), h[g] = p) : p instanceof Promise ? Object.defineProperty(h, g, {
      get() {
        return u(p);
      }
    }) : he.has(p) ? h[g] = we(p, u) : h[g] = p;
  }), Object.freeze(h);
}, s = /* @__PURE__ */ new WeakMap(), a = [1, 1], f = (l) => {
  if (!kt(l))
    throw new Error("object required");
  const c = s.get(l);
  if (c)
    return c;
  let u = a[0];
  const d = /* @__PURE__ */ new Set(), h = (C, S = ++a[0]) => {
    u !== S && (u = S, d.forEach((b) => b(C, S)));
  };
  let g = a[1];
  const p = (C = ++a[1]) => (g !== C && !d.size && (g = C, w.forEach(([S]) => {
    const b = S[1](C);
    b > u && (u = b);
  })), u), P = (C) => (S, b) => {
    const y = [...S];
    y[1] = [C, ...y[1]], h(y, b);
  }, w = /* @__PURE__ */ new Map(), N = (C, S) => {
    if (it && w.has(C))
      throw new Error("prop listener already exists");
    if (d.size) {
      const b = S[3](P(C));
      w.set(C, [S, b]);
    } else
      w.set(C, [S]);
  }, $ = (C) => {
    var b;
    const S = w.get(C);
    S && (w.delete(C), (b = S[1]) == null || b.call(S));
  }, I = (C) => (d.add(C), d.size === 1 && w.forEach(([b, y], v) => {
    if (it && y)
      throw new Error("remove already exists");
    const m = b[3](P(v));
    w.set(v, [b, m]);
  }), () => {
    d.delete(C), d.size === 0 && w.forEach(([b, y], v) => {
      y && (y(), w.set(v, [b]));
    });
  }), z = Array.isArray(l) ? [] : Object.create(Object.getPrototypeOf(l)), T = t(z, {
    deleteProperty(C, S) {
      const b = Reflect.get(C, S);
      $(S);
      const y = Reflect.deleteProperty(C, S);
      return y && h(["delete", [S], b]), y;
    },
    set(C, S, b, y) {
      var x;
      const v = Reflect.has(C, S), m = Reflect.get(C, S, y);
      if (v && (e(m, b) || s.has(b) && e(m, s.get(b))))
        return !0;
      $(S), kt(b) && (b = Zi(b) || b);
      let A = b;
      if (!((x = Object.getOwnPropertyDescriptor(C, S)) != null && x.set))
        if (b instanceof Promise)
          b.then((k) => {
            b.status = "fulfilled", b.value = k, h(["resolve", [S], k]);
          }).catch((k) => {
            b.status = "rejected", b.reason = k, h(["reject", [S], k]);
          });
        else {
          !he.has(b) && n(b) && (A = on(b));
          const k = !_e.has(A) && he.get(A);
          k && N(S, k);
        }
      return Reflect.set(C, S, A, y), h(["set", [S], b, m]), !0;
    }
  });
  s.set(l, T);
  const j = [z, p, o, I];
  return he.set(T, j), Reflect.ownKeys(l).forEach((C) => {
    const S = Object.getOwnPropertyDescriptor(l, C);
    S.get || S.set ? Object.defineProperty(z, C, S) : T[C] = l[C];
  }), T;
}) => [
  // public functions
  f,
  // shared state
  he,
  _e,
  // internal things
  e,
  t,
  n,
  r,
  i,
  o,
  s,
  a
], [Qi] = Ji();
function on(e = {}) {
  return Qi(e);
}
function Pn(e, t, n) {
  const r = he.get(e);
  it && !r && console.warn("Please use proxy object");
  let i;
  const o = [], s = r[3];
  let a = !1;
  const l = s((c) => {
    if (o.push(c), n) {
      t(o.splice(0));
      return;
    }
    i || (i = Promise.resolve().then(() => {
      i = void 0, a && t(o.splice(0));
    }));
  });
  return a = !0, () => {
    a = !1, l();
  };
}
function we(e, t) {
  const n = he.get(e);
  it && !n && console.warn("Please use proxy object");
  const [r, i, o] = n;
  return o(r, i(), t);
}
function ot(e) {
  return _e.add(e), e;
}
function eo(e, t) {
  Object.keys(t).forEach((i) => {
    if (Object.getOwnPropertyDescriptor(e, i))
      throw new Error("object property already defined");
    const o = t[i], { get: s, set: a } = typeof o == "function" ? { get: o } : o, f = {};
    f.get = () => s(we(r)), a && (f.set = (l) => a(r, l)), Object.defineProperty(e, i, f);
  });
  const r = on(e);
  return r;
}
function Sn(e, t, n) {
  typeof n.value == "object" && (n.value = Ee(n.value)), !n.enumerable || n.get || n.set || !n.configurable || !n.writable || t === "__proto__" ? Object.defineProperty(e, t, n) : e[t] = n.value;
}
function Ee(e) {
  if (typeof e != "object")
    return e;
  var t = 0, n, r, i, o = Object.prototype.toString.call(e);
  if (o === "[object Object]" ? i = Object.create(e.__proto__ || null) : o === "[object Array]" ? i = Array(e.length) : o === "[object Set]" ? (i = /* @__PURE__ */ new Set(), e.forEach(function(s) {
    i.add(Ee(s));
  })) : o === "[object Map]" ? (i = /* @__PURE__ */ new Map(), e.forEach(function(s, a) {
    i.set(Ee(a), Ee(s));
  })) : o === "[object Date]" ? i = /* @__PURE__ */ new Date(+e) : o === "[object RegExp]" ? i = new RegExp(e.source, e.flags) : o === "[object DataView]" ? i = new e.constructor(Ee(e.buffer)) : o === "[object ArrayBuffer]" ? i = e.slice(0) : o.slice(-6) === "Array]" && (i = new e.constructor(e)), i) {
    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      Sn(i, r[t], Object.getOwnPropertyDescriptor(e, r[t]));
    for (t = 0, r = Object.getOwnPropertyNames(e); t < r.length; t++)
      Object.hasOwnProperty.call(i, n = r[t]) && i[n] === e[n] || Sn(i, n, Object.getOwnPropertyDescriptor(e, n));
  }
  return i || e;
}
var to = Object.defineProperty, no = (e, t, n) => t in e ? to(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, E = (e, t, n) => (no(e, typeof t != "symbol" ? t + "" : t, n), n);
function ro(e) {
  for (; e.length > 0; )
    e.pop();
  return e;
}
var Cn = (e, ...t) => (typeof e == "function" ? e(...t) : e) ?? void 0, ie = (e) => e, io = () => {
}, On = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (e++, e.toString(36));
})(), oo = () => process.env.NODE_ENV !== "production", st = (e) => Array.isArray(e), Ie = (e) => !(e == null || typeof e != "object" || st(e)), so = (e) => typeof e == "number" && !Number.isNaN(e), Q = (e) => typeof e == "string", at = (e) => typeof e == "function", ao = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
function lt(e) {
  if (!lo(e) || e === void 0)
    return e;
  const t = Reflect.ownKeys(e).filter((r) => typeof r == "string"), n = {};
  for (const r of t) {
    const i = e[r];
    i !== void 0 && (n[r] = lt(i));
  }
  return n;
}
var lo = (e) => e && typeof e == "object" && e.constructor === Object;
function Dt(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(t);
}
function He(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  if ((e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production")
    throw new Error(t);
}
function lr(e, ...t) {
  for (const n of t) {
    const r = lt(n);
    for (const i in r)
      Ie(n[i]) ? (e[i] || (e[i] = {}), lr(e[i], n[i])) : e[i] = n[i];
  }
  return e;
}
function xn(e) {
  return Ee(e);
}
function Z(e) {
  return Q(e) ? { type: e } : e;
}
function ae(e) {
  return e ? st(e) ? e.slice() : [e] : [];
}
function cr(e) {
  return Ie(e) && e.predicate != null;
}
var co = () => !0;
function sn(e, t, n, r) {
  return (i) => {
    var o;
    return Q(i) ? !!((o = e[i]) != null && o.call(e, t, n, r)) : at(i) ? i(t, n, r) : i.predicate(e)(t, n, r);
  };
}
function uo(...e) {
  return {
    predicate: (t) => (n, r, i) => e.map(sn(t, n, r, i)).some(Boolean)
  };
}
function fo(...e) {
  return {
    predicate: (t) => (n, r, i) => e.map(sn(t, n, r, i)).every(Boolean)
  };
}
function ho(e) {
  return {
    predicate: (t) => (n, r, i) => !sn(t, n, r, i)(e)
  };
}
function po(...e) {
  return (t, n, r) => r.state.matches(...e);
}
var go = { or: uo, and: fo, not: ho, stateIn: po };
function ur(e, t) {
  return e = e ?? co, (n, r, i) => {
    if (Q(e)) {
      const o = t[e];
      return at(o) ? o(n, r, i) : o;
    }
    return cr(e) ? e.predicate(t)(n, r, i) : e == null ? void 0 : e(n, r, i);
  };
}
function Lt(e, t) {
  return (n, r, i) => cr(e) ? e.predicate(t)(n, r, i) : e;
}
function yo(e) {
  var o, s;
  const t = e.computed ?? ie({}), n = e.context ?? ie({}), r = e.initial ? (s = (o = e.states) == null ? void 0 : o[e.initial]) == null ? void 0 : s.tags : [], i = on({
    value: e.initial ?? "",
    previousValue: "",
    event: ie({}),
    previousEvent: ie({}),
    context: eo(n, t),
    done: !1,
    tags: r ?? [],
    hasTag(a) {
      return this.tags.includes(a);
    },
    matches(...a) {
      return a.includes(this.value);
    },
    can(a) {
      return ie(this).nextEvents.includes(a);
    },
    get nextEvents() {
      var l, c;
      const a = ((c = (l = e.states) == null ? void 0 : l[this.value]) == null ? void 0 : c.on) ?? {}, f = (e == null ? void 0 : e.on) ?? {};
      return Object.keys({ ...a, ...f });
    },
    get changed() {
      return this.event.value === "machine.init" || !this.previousValue ? !1 : this.value !== this.previousValue;
    }
  });
  return ie(i);
}
function ke(e, t) {
  return (n, r) => {
    if (so(e))
      return e;
    if (at(e))
      return e(n, r);
    if (Q(e)) {
      const i = Number.parseFloat(e);
      if (!Number.isNaN(i))
        return i;
      if (t) {
        const o = t == null ? void 0 : t[e];
        return He(
          o == null,
          `[@zag-js/core > determine-delay] Cannot determine delay for \`${e}\`. It doesn't exist in \`options.delays\``
        ), at(o) ? o(n, r) : o;
      }
    }
  };
}
function vo(e) {
  return Q(e) ? { target: e } : e;
}
function bo(e, t) {
  return (n, r, i) => ae(e).map(vo).find((o) => ur(o.guard, t)(n, r, i) ?? o.target ?? o.actions);
}
var mo = class {
  // Let's get started!
  constructor(e, t) {
    var r, i, o, s, a, f;
    E(
      this,
      "status",
      "Not Started"
      /* NotStarted */
    ), E(this, "state"), E(this, "initialState"), E(this, "initialContext"), E(this, "id"), E(
      this,
      "type",
      "machine"
      /* Machine */
    ), E(this, "activityEvents", /* @__PURE__ */ new Map()), E(this, "delayedEvents", /* @__PURE__ */ new Map()), E(this, "stateListeners", /* @__PURE__ */ new Set()), E(this, "doneListeners", /* @__PURE__ */ new Set()), E(this, "contextWatchers", /* @__PURE__ */ new Set()), E(this, "removeStateListener", io), E(this, "parent"), E(this, "children", /* @__PURE__ */ new Map()), E(this, "guardMap"), E(this, "actionMap"), E(this, "delayMap"), E(this, "activityMap"), E(this, "sync"), E(this, "options"), E(this, "config"), E(this, "start", (l) => {
      if (this.state.value = "", this.state.tags = [], this.status === "Running")
        return this;
      this.status = "Running", this.removeStateListener = Pn(
        this.state,
        () => {
          this.stateListeners.forEach((p) => {
            p(this.stateSnapshot);
          });
        },
        this.sync
      ), this.setupContextWatchers(), this.executeActivities(
        Z(
          "machine.start"
          /* Start */
        ),
        ae(this.config.activities),
        "machine.start"
        /* Start */
      ), this.executeActions(this.config.entry, Z(
        "machine.start"
        /* Start */
      ));
      const c = Z(
        "machine.init"
        /* Init */
      ), u = Ie(l) ? l.value : l, d = Ie(l) ? l.context : void 0;
      d && this.setContext(d);
      const h = {
        target: u ?? this.config.initial
      }, g = this.getNextStateInfo(h, c);
      return this.initialState = g, this.performStateChangeEffects(this.state.value, g, c), this;
    }), E(this, "setupContextWatchers", () => {
      const { watch: l } = this.config;
      if (!l)
        return;
      let c = we(this.state.context);
      const u = Pn(this.state.context, () => {
        var h;
        const d = we(this.state.context);
        for (const [g, p] of Object.entries(l))
          (((h = this.options.compareFns) == null ? void 0 : h[g]) ?? Object.is)(c[g], d[g]) || this.executeActions(p, this.state.event);
        c = d;
      });
      this.contextWatchers.add(u);
    }), E(this, "stop", () => {
      if (this.status !== "Stopped")
        return this.performExitEffects(this.state.value, Z(
          "machine.stop"
          /* Stop */
        )), this.executeActions(this.config.exit, Z(
          "machine.stop"
          /* Stop */
        )), this.setState(""), this.setEvent(
          "machine.stop"
          /* Stop */
        ), this.stopStateListeners(), this.stopChildren(), this.stopActivities(), this.stopDelayedEvents(), this.stopContextWatchers(), this.status = "Stopped", this;
    }), E(this, "stopStateListeners", () => {
      this.removeStateListener(), this.stateListeners.clear();
    }), E(this, "stopContextWatchers", () => {
      this.contextWatchers.forEach((l) => l()), this.contextWatchers.clear();
    }), E(this, "stopDelayedEvents", () => {
      this.delayedEvents.forEach((l) => {
        l.forEach((c) => c());
      }), this.delayedEvents.clear();
    }), E(this, "stopActivities", (l) => {
      var c, u;
      l ? ((c = this.activityEvents.get(l)) == null || c.forEach((d) => d()), (u = this.activityEvents.get(l)) == null || u.clear(), this.activityEvents.delete(l)) : (this.activityEvents.forEach((d) => {
        d.forEach((h) => h()), d.clear();
      }), this.activityEvents.clear());
    }), E(this, "sendChild", (l, c) => {
      const u = Z(l), d = Cn(c, this.contextSnapshot), h = this.children.get(d);
      h || He(`[@zag-js/core] Cannot send '${u.type}' event to unknown child`), h.send(u);
    }), E(this, "stopChild", (l) => {
      this.children.has(l) || He(`[@zag-js/core > stop-child] Cannot stop unknown child ${l}`), this.children.get(l).stop(), this.children.delete(l);
    }), E(this, "removeChild", (l) => {
      this.children.delete(l);
    }), E(this, "stopChildren", () => {
      this.children.forEach((l) => l.stop()), this.children.clear();
    }), E(this, "setParent", (l) => {
      this.parent = l;
    }), E(this, "spawn", (l, c) => {
      const u = Cn(l);
      return c && (u.id = c), u.type = "machine.actor", u.setParent(this), this.children.set(u.id, ie(u)), u.onDone(() => {
        this.removeChild(u.id);
      }).start(), ie(ot(u));
    }), E(this, "stopActivity", (l) => {
      var u;
      if (!this.state.value)
        return;
      const c = this.activityEvents.get(this.state.value);
      (u = c == null ? void 0 : c.get(l)) == null || u(), c == null || c.delete(l);
    }), E(this, "addActivityCleanup", (l, c, u) => {
      var d;
      l && (this.activityEvents.has(l) ? (d = this.activityEvents.get(l)) == null || d.set(c, u) : this.activityEvents.set(l, /* @__PURE__ */ new Map([[c, u]])));
    }), E(this, "setState", (l) => {
      this.state.previousValue = this.state.value, this.state.value = l;
      const c = this.getStateNode(l);
      l == null ? ro(this.state.tags) : this.state.tags = ae(c == null ? void 0 : c.tags);
    }), E(this, "setContext", (l) => {
      l && lr(this.state.context, lt(l));
    }), E(this, "setOptions", (l) => {
      const c = lt(l);
      this.actionMap = { ...this.actionMap, ...c.actions }, this.delayMap = { ...this.delayMap, ...c.delays }, this.activityMap = { ...this.activityMap, ...c.activities }, this.guardMap = { ...this.guardMap, ...c.guards };
    }), E(this, "getStateNode", (l) => {
      var c;
      if (l)
        return (c = this.config.states) == null ? void 0 : c[l];
    }), E(this, "getNextStateInfo", (l, c) => {
      const u = this.determineTransition(l, c), d = !(u != null && u.target), h = (u == null ? void 0 : u.target) ?? this.state.value, g = this.state.value !== h, p = this.getStateNode(h), w = {
        reenter: !d && !g && !(u != null && u.internal),
        transition: u,
        stateNode: p,
        target: h,
        changed: g
      };
      return this.log("NextState:", `[${c.type}]`, this.state.value, "---->", w.target), w;
    }), E(this, "getAfterActions", (l, c) => {
      let u;
      return {
        entry: () => {
          u = globalThis.setTimeout(() => {
            const d = this.getNextStateInfo(l, this.state.event);
            this.performStateChangeEffects(this.state.value, d, this.state.event);
          }, c);
        },
        exit: () => {
          globalThis.clearTimeout(u);
        }
      };
    }), E(this, "getDelayedEventActions", (l) => {
      const c = this.getStateNode(l), u = this.state.event;
      if (!c || !c.after)
        return;
      const d = [], h = [];
      if (st(c.after)) {
        const g = this.determineTransition(c.after, u);
        if (!g)
          return;
        if (!ao(g, "delay"))
          throw new Error(`[@zag-js/core > after] Delay is required for after transition: ${JSON.stringify(g)}`);
        const P = ke(g.delay, this.delayMap)(this.contextSnapshot, u), w = this.getAfterActions(g, P);
        return d.push(w.entry), h.push(w.exit), { entries: d, exits: h };
      }
      if (Ie(c.after))
        for (const g in c.after) {
          const p = c.after[g], w = ke(g, this.delayMap)(this.contextSnapshot, u), N = this.getAfterActions(p, w);
          d.push(N.entry), h.push(N.exit);
        }
      return { entries: d, exits: h };
    }), E(this, "executeActions", (l, c) => {
      var d;
      const u = Lt(l, this.guardMap)(this.contextSnapshot, c, this.guardMeta);
      for (const h of ae(u)) {
        const g = Q(h) ? (d = this.actionMap) == null ? void 0 : d[h] : h;
        Dt(
          Q(h) && !g,
          `[@zag-js/core > execute-actions] No implementation found for action: \`${h}\``
        ), g == null || g(this.state.context, c, this.meta);
      }
    }), E(this, "executeActivities", (l, c, u) => {
      var d;
      for (const h of c) {
        const g = Q(h) ? (d = this.activityMap) == null ? void 0 : d[h] : h;
        if (!g) {
          Dt(`[@zag-js/core > execute-activity] No implementation found for activity: \`${h}\``);
          continue;
        }
        const p = g(this.state.context, l, this.meta);
        if (p) {
          const P = Q(h) ? h : h.name || On();
          this.addActivityCleanup(u ?? this.state.value, P, p);
        }
      }
    }), E(this, "createEveryActivities", (l, c) => {
      if (l)
        if (st(l)) {
          const u = ae(l).find((p) => {
            const P = p.delay, N = ke(P, this.delayMap)(this.contextSnapshot, this.state.event);
            return ur(p.guard, this.guardMap)(this.contextSnapshot, this.state.event, this.guardMeta) ?? N != null;
          });
          if (!u)
            return;
          const h = ke(u.delay, this.delayMap)(this.contextSnapshot, this.state.event);
          c(() => {
            const p = globalThis.setInterval(() => {
              this.executeActions(u.actions, this.state.event);
            }, h);
            return () => {
              globalThis.clearInterval(p);
            };
          });
        } else
          for (const u in l) {
            const d = l == null ? void 0 : l[u], g = ke(u, this.delayMap)(this.contextSnapshot, this.state.event);
            c(() => {
              const P = globalThis.setInterval(() => {
                this.executeActions(d, this.state.event);
              }, g);
              return () => {
                globalThis.clearInterval(P);
              };
            });
          }
    }), E(this, "setEvent", (l) => {
      this.state.previousEvent = this.state.event, this.state.event = ot(Z(l));
    }), E(this, "performExitEffects", (l, c) => {
      const u = this.state.value;
      if (u === "")
        return;
      const d = l ? this.getStateNode(l) : void 0;
      this.stopActivities(u);
      const h = Lt(d == null ? void 0 : d.exit, this.guardMap)(this.contextSnapshot, c, this.guardMeta), g = ae(h), p = this.delayedEvents.get(u);
      p && g.push(...p), this.executeActions(g, c);
    }), E(this, "performEntryEffects", (l, c) => {
      const u = this.getStateNode(l), d = ae(u == null ? void 0 : u.activities);
      this.createEveryActivities(u == null ? void 0 : u.every, (P) => {
        d.unshift(P);
      }), d.length > 0 && this.executeActivities(c, d);
      const h = Lt(u == null ? void 0 : u.entry, this.guardMap)(
        this.contextSnapshot,
        c,
        this.guardMeta
      ), g = ae(h), p = this.getDelayedEventActions(l);
      u != null && u.after && p && (this.delayedEvents.set(l, p == null ? void 0 : p.exits), g.push(...p.entries)), this.executeActions(g, c), (u == null ? void 0 : u.type) === "final" && (this.state.done = !0, this.doneListeners.forEach((P) => {
        P(this.stateSnapshot);
      }), this.stop());
    }), E(this, "performTransitionEffects", (l, c) => {
      const u = this.determineTransition(l, c);
      this.executeActions(u == null ? void 0 : u.actions, c);
    }), E(this, "performStateChangeEffects", (l, c, u) => {
      this.setEvent(u);
      const d = c.changed || c.reenter;
      d && this.performExitEffects(l, u), this.performTransitionEffects(c.transition, u), this.setState(c.target), d && this.performEntryEffects(c.target, u);
    }), E(this, "determineTransition", (l, c) => {
      const u = bo(l, this.guardMap);
      return u == null ? void 0 : u(this.contextSnapshot, c, this.guardMeta);
    }), E(this, "sendParent", (l) => {
      var u;
      this.parent || He("[@zag-js/core > send-parent] Cannot send event to an unknown parent");
      const c = Z(l);
      (u = this.parent) == null || u.send(c);
    }), E(this, "log", (...l) => {
      oo() && this.options.debug && console.log(...l);
    }), E(this, "send", (l) => {
      const c = Z(l);
      this.transition(this.state.value, c);
    }), E(this, "transition", (l, c) => {
      var p, P;
      const u = Q(l) ? this.getStateNode(l) : l == null ? void 0 : l.stateNode, d = Z(c);
      if (!u && !this.config.on) {
        const w = this.status === "Stopped" ? "[@zag-js/core > transition] Cannot transition a stopped machine" : `[@zag-js/core > transition] State does not have a definition for \`state\`: ${l}, \`event\`: ${d.type}`;
        Dt(w);
        return;
      }
      const h = ((p = u == null ? void 0 : u.on) == null ? void 0 : p[d.type]) ?? ((P = this.config.on) == null ? void 0 : P[d.type]), g = this.getNextStateInfo(h, d);
      return this.performStateChangeEffects(this.state.value, g, d), g.stateNode;
    }), E(this, "subscribe", (l) => (this.stateListeners.add(l), this.status === "Running" && l(this.stateSnapshot), () => {
      this.stateListeners.delete(l);
    })), E(this, "onDone", (l) => (this.doneListeners.add(l), this)), E(this, "onTransition", (l) => (this.stateListeners.add(l), this.status === "Running" && l(this.stateSnapshot), this)), this.config = xn(e), this.options = xn(t ?? {}), this.id = this.config.id ?? `machine-${On()}`, this.guardMap = ((r = this.options) == null ? void 0 : r.guards) ?? {}, this.actionMap = ((i = this.options) == null ? void 0 : i.actions) ?? {}, this.delayMap = ((o = this.options) == null ? void 0 : o.delays) ?? {}, this.activityMap = ((s = this.options) == null ? void 0 : s.activities) ?? {}, this.sync = ((a = this.options) == null ? void 0 : a.sync) ?? !1, this.state = yo(this.config), this.initialContext = we(this.state.context);
    const n = Z(
      "machine.created"
      /* Created */
    );
    this.executeActions((f = this.config) == null ? void 0 : f.created, n);
  }
  // immutable state value
  get stateSnapshot() {
    return ie(we(this.state));
  }
  getState() {
    return this.stateSnapshot;
  }
  // immutable context value
  get contextSnapshot() {
    return this.stateSnapshot.context;
  }
  /**
   * A reference to the instance methods of the machine.
   * Useful when spawning child machines and managing the communication between them.
   */
  get self() {
    const e = this;
    return {
      id: this.id,
      send: this.send.bind(this),
      sendParent: this.sendParent.bind(this),
      sendChild: this.sendChild.bind(this),
      stop: this.stop.bind(this),
      stopChild: this.stopChild.bind(this),
      spawn: this.spawn.bind(this),
      stopActivity: this.stopActivity.bind(this),
      get state() {
        return e.stateSnapshot;
      },
      get initialContext() {
        return e.initialContext;
      },
      get initialState() {
        var t;
        return ((t = e.initialState) == null ? void 0 : t.target) ?? "";
      }
    };
  }
  get meta() {
    var e;
    return {
      state: this.stateSnapshot,
      guards: this.guardMap,
      send: this.send.bind(this),
      self: this.self,
      initialContext: this.initialContext,
      initialState: ((e = this.initialState) == null ? void 0 : e.target) ?? "",
      getState: () => this.stateSnapshot,
      getAction: (t) => this.actionMap[t],
      getGuard: (t) => this.guardMap[t]
    };
  }
  get guardMeta() {
    return {
      state: this.stateSnapshot
    };
  }
  get [Symbol.toStringTag]() {
    return "Machine";
  }
}, dr = (e, t) => new mo(e, t);
function wo(e, t, n) {
  return {
    isPresent: e.matches("mounted", "unmountSuspended"),
    setNode(r) {
      r && t({ type: "NODE.SET", node: r });
    }
  };
}
var { and: Eo, or: Po } = go;
function De(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function So(e) {
  const t = e.present ? "mounted" : "unmounted";
  return dr(
    {
      initial: t,
      watch: {
        present: ["raisePresenceChange", "setPrevPresent"]
      },
      context: {
        node: null,
        styles: null,
        prevAnimationName: "",
        present: !1,
        ...e
      },
      on: {
        "NODE.SET": {
          actions: ["setNode", "setStyles"]
        },
        "PRESENCE.CHANGED": [
          {
            guard: "isPresent",
            target: "mounted",
            actions: ["setPrevAnimationName"]
          },
          {
            guard: Po("isAnimationNone", "isDisplayNone"),
            target: "unmounted",
            actions: ["invokeOnExitComplete"]
          },
          {
            guard: Eo("wasPresent", "isAnimating"),
            target: "unmountSuspended"
          },
          { target: "unmounted", actions: ["invokeOnExitComplete"] }
        ]
      },
      states: {
        mounted: {
          on: {
            UNMOUNT: "unmounted"
          }
        },
        unmountSuspended: {
          activities: ["trackAnimationEvents"],
          on: {
            MOUNT: {
              target: "mounted",
              actions: ["setPrevAnimationName"]
            },
            "ANIMATION.END": {
              target: "unmounted",
              actions: ["invokeOnExitComplete"]
            }
          }
        },
        unmounted: {
          entry: ["clearPrevAnimationName"],
          on: {
            MOUNT: "mounted"
          }
        }
      }
    },
    {
      guards: {
        isPresent: (n) => !!n.present,
        isAnimationNone: (n) => De(n.styles) === "none",
        isDisplayNone: (n) => {
          var r;
          return ((r = n.styles) == null ? void 0 : r.display) === "none";
        },
        wasPresent: (n) => !!n.prevPresent,
        isAnimating: (n) => n.prevAnimationName !== De(n.styles)
      },
      actions: {
        invokeOnExitComplete(n) {
          var r;
          (r = n.onExitComplete) == null || r.call(n);
        },
        setNode(n, r) {
          n.node = ot(r.node);
        },
        setStyles(n, r) {
          const i = r.node.ownerDocument.defaultView || window;
          n.styles = ot(i.getComputedStyle(r.node));
        },
        raisePresenceChange(n, r, { send: i }) {
          i("PRESENCE.CHANGED");
        },
        setPrevPresent(n) {
          n.prevPresent = n.present;
        },
        setPrevAnimationName(n) {
          requestAnimationFrame(() => {
            n.prevAnimationName = De(n.styles);
          });
        },
        clearPrevAnimationName(n) {
          n.prevAnimationName = "";
        }
      },
      activities: {
        trackAnimationEvents(n, r, { send: i }) {
          const o = n.node;
          if (!o)
            return;
          const s = (f) => {
            f.target === o && (n.prevAnimationName = De(n.styles));
          }, a = (f) => {
            const c = De(n.styles).includes(f.animationName);
            f.target === o && c && i("ANIMATION.END");
          };
          return o.addEventListener("animationstart", s), o.addEventListener("animationcancel", a), o.addEventListener("animationend", a), () => {
            o.removeEventListener("animationstart", s), o.removeEventListener("animationcancel", a), o.removeEventListener("animationend", a);
          };
        }
      }
    }
  );
}
tr()(["onExitComplete", "present"]);
const [Co, Oo] = bt({
  hookName: "useRenderStrategyContext",
  providerName: "<RenderStrategyProvider />"
}), fr = (e) => rn()(e, ["lazyMount", "unmountOnExit"]), hr = (e) => {
  const [t, n] = fr(e), [r, i] = X(!1), [o, s] = ar(So(n), {
    context: n
  }), a = V(() => wo(o, s));
  return et(() => {
    a().isPresent && i(!0);
  }), V(() => ({
    isUnmounted: !a().isPresent && !r() && t.lazyMount || t.unmountOnExit && !a().isPresent && r(),
    isPresent: a().isPresent,
    presenceProps: {
      ref: a().setNode,
      hidden: !a().isPresent,
      "data-state": n.present ? "open" : "closed"
    }
  }));
}, [xo, pr] = bt({
  hookName: "usePresenceContext",
  providerName: "<PresenceProvider />"
}), Ao = (e) => typeof e == "function", No = (e, ...t) => Ao(e) ? e(...t) : e;
var Ze = (e, t = []) => ({
  parts: (...n) => {
    if (To(t))
      return Ze(e, n);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...n) => Ze(e, [...t, ...n]),
  rename: (n) => Ze(n, t),
  keys: () => t,
  build: () => [...new Set(t)].reduce(
    (n, r) => Object.assign(n, {
      [r]: {
        selector: [
          `&[data-scope="${ve(e)}"][data-part="${ve(r)}"]`,
          `& [data-scope="${ve(e)}"][data-part="${ve(r)}"]`
        ].join(", "),
        attrs: { "data-scope": ve(e), "data-part": ve(r) }
      }
    }),
    {}
  )
}), ve = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), To = (e) => e.length === 0, Me = (e) => typeof e == "object" && (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE && typeof (e == null ? void 0 : e.nodeName) == "string", gr = (e) => e.nodeType === Node.DOCUMENT_NODE, ko = (e) => e != null && e === e.window, Do = (e) => e.nodeType !== void 0, Lo = (e) => e && Do(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
function ct(e, t) {
  return !e || !t || !Me(e) || !Me(t) ? !1 : e === t || e.contains(t);
}
function mt(e) {
  return gr(e) ? e : ko(e) ? e.document : (e == null ? void 0 : e.ownerDocument) ?? document;
}
function yr(e) {
  var t;
  return Lo(e) ? yr(e.host) : gr(e) ? e.defaultView ?? window : Me(e) ? ((t = e.ownerDocument) == null ? void 0 : t.defaultView) ?? window : window;
}
function Be(e) {
  var t;
  return ((t = e.composedPath) == null ? void 0 : t.call(e)[0]) ?? e.target;
}
var $o = () => typeof document < "u";
function Fo() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
var _o = (e) => $o() && e.test(Fo()), Io = () => _o(/iP(hone|ad|od)|iOS/);
function jo(e) {
  const t = /* @__PURE__ */ new Set();
  function n(r) {
    const i = globalThis.requestAnimationFrame(r);
    t.add(() => globalThis.cancelAnimationFrame(i));
  }
  return n(() => n(e)), function() {
    t.forEach((i) => i());
  };
}
function Ke(e) {
  const t = globalThis.requestAnimationFrame(e);
  return () => {
    globalThis.cancelAnimationFrame(t);
  };
}
function Ro(e) {
  const t = {
    getRootNode: (n) => {
      var r;
      return ((r = n.getRootNode) == null ? void 0 : r.call(n)) ?? document;
    },
    getDoc: (n) => mt(t.getRootNode(n)),
    getWin: (n) => t.getDoc(n).defaultView ?? window,
    getActiveElement: (n) => t.getDoc(n).activeElement,
    isActiveElement: (n, r) => r === t.getActiveElement(n),
    getById: (n, r) => t.getRootNode(n).getElementById(r),
    setValue: (n, r) => {
      if (n == null || r == null)
        return;
      const i = r.toString();
      n.value !== i && (n.value = r.toString());
    }
  };
  return { ...t, ...e };
}
var Gt = (e, t, n, r) => {
  const i = typeof e == "function" ? e() : e;
  return i == null || i.addEventListener(t, n, r), () => {
    i == null || i.removeEventListener(t, n, r);
  };
}, Mo = (e) => e.button === 2 || Bo() && e.ctrlKey && e.button === 0, Bo = () => /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
function An(e, t, n) {
  if (!e)
    return;
  const r = e.ownerDocument.defaultView || window, i = new r.CustomEvent(t, n);
  return e.dispatchEvent(i);
}
var Nn = (e, ...t) => (typeof e == "function" ? e(...t) : e) ?? void 0, Tn = (...e) => (...t) => {
  e.forEach(function(n) {
    n == null || n(...t);
  });
};
function vr(e) {
  if (!Ko(e) || e === void 0)
    return e;
  const t = Reflect.ownKeys(e).filter((r) => typeof r == "string"), n = {};
  for (const r of t) {
    const i = e[r];
    i !== void 0 && (n[r] = vr(i));
  }
  return n;
}
var Ko = (e) => e && typeof e == "object" && e.constructor === Object;
function zo(...e) {
  const t = e.length === 1 ? e[0] : e[1];
  (e.length === 2 ? e[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(t);
}
const [Aa, Wo] = bt({
  hookName: "useEnvironmentContext",
  providerName: "<EnvironmentProvider />",
  strict: !1
});
var Vo = (e) => typeof e == "object" && e !== null && e.nodeType === 1;
function Uo(e) {
  return Vo(e) ? e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0 : !1;
}
var Go = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type";
function br(e) {
  return !e || e.closest("[inert]") ? !1 : e.matches(Go) && Uo(e);
}
function qo(e) {
  const t = {
    each(n) {
      var r;
      for (let i = 0; i < ((r = e.frames) == null ? void 0 : r.length); i += 1) {
        const o = e.frames[i];
        o && n(o);
      }
    },
    addEventListener(n, r, i) {
      return t.each((o) => {
        try {
          o.document.addEventListener(n, r, i);
        } catch {
        }
      }), () => {
        try {
          t.removeEventListener(n, r, i);
        } catch {
        }
      };
    },
    removeEventListener(n, r, i) {
      t.each((o) => {
        try {
          o.document.removeEventListener(n, r, i);
        } catch {
        }
      });
    }
  };
  return t;
}
var kn = "pointerdown.outside", Dn = "focus.outside";
function Xo(e) {
  const t = e.composedPath() ?? [e.target];
  for (const n of t)
    if (Me(n) && br(n))
      return !0;
  return !1;
}
var mr = (e) => "clientY" in e;
function Yo(e, t) {
  if (!mr(t) || !e)
    return !1;
  const n = e.getBoundingClientRect();
  return n.width === 0 || n.height === 0 ? !1 : n.top <= t.clientY && t.clientY <= n.top + n.height && n.left <= t.clientX && t.clientX <= n.left + n.width;
}
function Ho(e) {
  const t = Be(e);
  if (!t || !mr(e))
    return !1;
  const r = t.scrollHeight > t.clientHeight && e.clientX > t.clientWidth, o = t.scrollWidth > t.clientWidth && e.clientY > t.clientHeight;
  return r || o;
}
function Zo(e, t) {
  const { exclude: n, onFocusOutside: r, onPointerDownOutside: i, onInteractOutside: o } = t;
  if (!e)
    return;
  const s = mt(e), a = yr(e), f = qo(a);
  function l(p) {
    const P = Be(p);
    return !Me(P) || ct(e, P) || Yo(e, p) || Ho(p) ? !1 : !(n != null && n(P));
  }
  let c;
  function u(p) {
    function P() {
      if (!(!e || !l(p))) {
        if (i || o) {
          const w = Tn(i, o);
          e.addEventListener(kn, w, { once: !0 });
        }
        An(e, kn, {
          bubbles: !1,
          cancelable: !0,
          detail: {
            originalEvent: p,
            contextmenu: Mo(p),
            focusable: Xo(p)
          }
        });
      }
    }
    p.pointerType === "touch" ? (f.removeEventListener("click", P), s.removeEventListener("click", P), c = P, s.addEventListener("click", P, { once: !0 }), f.addEventListener("click", P, { once: !0 })) : P();
  }
  const d = /* @__PURE__ */ new Set(), h = setTimeout(() => {
    d.add(f.addEventListener("pointerdown", u, !0)), d.add(Gt(s, "pointerdown", u, !0));
  }, 0);
  function g(p) {
    if (!(!e || !l(p))) {
      if (r || o) {
        const P = Tn(r, o);
        e.addEventListener(Dn, P, { once: !0 });
      }
      An(e, Dn, {
        bubbles: !1,
        cancelable: !0,
        detail: {
          originalEvent: p,
          contextmenu: !1,
          focusable: br(Be(p))
        }
      });
    }
  }
  return d.add(Gt(s, "focusin", g, !0)), d.add(f.addEventListener("focusin", g, !0)), () => {
    clearTimeout(h), c && (f.removeEventListener("click", c), s.removeEventListener("click", c)), d.forEach((p) => p());
  };
}
function Jo(e, t) {
  const { defer: n } = t, r = n ? Ke : (o) => o(), i = [];
  return i.push(
    r(() => {
      const o = typeof e == "function" ? e() : e;
      i.push(Zo(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
function Qo(e, t) {
  const n = (r) => {
    r.key === "Escape" && (t == null || t(r));
  };
  return Gt(mt(e), "keydown", n);
}
var J = {
  layers: [],
  branches: [],
  count() {
    return this.layers.length;
  },
  pointerBlockingLayers() {
    return this.layers.filter((e) => e.pointerBlocking);
  },
  topMostPointerBlockingLayer() {
    return [...this.pointerBlockingLayers()].slice(-1)[0];
  },
  hasPointerBlockingLayer() {
    return this.pointerBlockingLayers().length > 0;
  },
  isBelowPointerBlockingLayer(e) {
    var r;
    const t = this.indexOf(e), n = this.topMostPointerBlockingLayer() ? this.indexOf((r = this.topMostPointerBlockingLayer()) == null ? void 0 : r.node) : -1;
    return t < n;
  },
  isTopMost(e) {
    const t = this.layers[this.count() - 1];
    return (t == null ? void 0 : t.node) === e;
  },
  getNestedLayers(e) {
    return Array.from(this.layers).slice(this.indexOf(e) + 1);
  },
  isInNestedLayer(e, t) {
    return this.getNestedLayers(e).some((n) => ct(n.node, t));
  },
  isInBranch(e) {
    return Array.from(this.branches).some((t) => ct(t, e));
  },
  add(e) {
    this.layers.push(e);
  },
  addBranch(e) {
    this.branches.push(e);
  },
  remove(e) {
    const t = this.indexOf(e);
    t < 0 || (t < this.count() - 1 && this.getNestedLayers(e).forEach((r) => r.dismiss()), this.layers.splice(t, 1));
  },
  removeBranch(e) {
    const t = this.branches.indexOf(e);
    t >= 0 && this.branches.splice(t, 1);
  },
  indexOf(e) {
    return this.layers.findIndex((t) => t.node === e);
  },
  dismiss(e) {
    var t;
    (t = this.layers[this.indexOf(e)]) == null || t.dismiss();
  },
  clear() {
    this.remove(this.layers[0].node);
  }
}, Ln;
function $n() {
  J.layers.forEach(({ node: e }) => {
    e.style.pointerEvents = J.isBelowPointerBlockingLayer(e) ? "none" : "auto";
  });
}
function es(e) {
  e.style.pointerEvents = "";
}
var $t = "data-inert";
function ts(e) {
  const t = mt(e);
  return J.hasPointerBlockingLayer() && !t.body.hasAttribute($t) && (Ln = document.body.style.pointerEvents, t.body.style.pointerEvents = "none", t.body.setAttribute($t, "")), () => {
    J.hasPointerBlockingLayer() || (t.body.style.pointerEvents = Ln, t.body.removeAttribute($t), t.body.style.length === 0 && t.body.removeAttribute("style"));
  };
}
function ns(e, t) {
  if (!e) {
    zo("[@zag-js/dismissable] node is `null` or `undefined`");
    return;
  }
  const { onDismiss: n, pointerBlocking: r, exclude: i, debug: o } = t, s = { dismiss: n, node: e, pointerBlocking: r };
  J.add(s), $n();
  function a(d) {
    var g, p;
    const h = Be(d.detail.originalEvent);
    J.isBelowPointerBlockingLayer(e) || J.isInBranch(h) || ((g = t.onPointerDownOutside) == null || g.call(t, d), (p = t.onInteractOutside) == null || p.call(t, d), !d.defaultPrevented && (o && console.log("onPointerDownOutside:", d.detail.originalEvent), n == null || n()));
  }
  function f(d) {
    var g, p;
    const h = Be(d.detail.originalEvent);
    J.isInBranch(h) || ((g = t.onFocusOutside) == null || g.call(t, d), (p = t.onInteractOutside) == null || p.call(t, d), !d.defaultPrevented && (o && console.log("onFocusOutside:", d.detail.originalEvent), n == null || n()));
  }
  function l(d) {
    var h;
    J.isTopMost(e) && ((h = t.onEscapeKeyDown) == null || h.call(t, d), !d.defaultPrevented && n && (d.preventDefault(), n()));
  }
  function c(d) {
    if (!e)
      return !1;
    const h = typeof i == "function" ? i() : i;
    return (Array.isArray(h) ? h : [h]).some((p) => ct(p, d)) || J.isInNestedLayer(e, d);
  }
  const u = [
    r ? ts(e) : void 0,
    Qo(e, l),
    Jo(e, { exclude: c, onFocusOutside: f, onPointerDownOutside: a })
  ];
  return () => {
    J.remove(e), $n(), es(e), u.forEach((d) => d == null ? void 0 : d());
  };
}
function rs(e, t) {
  const { defer: n } = t, r = n ? Ke : (o) => o(), i = [];
  return i.push(
    r(() => {
      const o = typeof e == "function" ? e() : e;
      i.push(ns(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
var Le = /* @__PURE__ */ new WeakMap(), G = [];
function is(e, t = {}) {
  const { rootEl: n } = t, r = e.filter(Boolean);
  if (r.length === 0)
    return;
  const i = r[0].ownerDocument || document, o = i.defaultView ?? window, s = new Set(r), a = /* @__PURE__ */ new Set(), f = n ?? i.body;
  let l = (h) => {
    for (let w of h.querySelectorAll("[data-live-announcer], [data-zag-top-layer]"))
      s.add(w);
    let g = (w) => {
      if (s.has(w) || a.has(w.parentElement) && w.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let N of s)
        if (w.contains(N))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, p = i.createTreeWalker(h, NodeFilter.SHOW_ELEMENT, { acceptNode: g }), P = g(h);
    if (P === NodeFilter.FILTER_ACCEPT && c(h), P !== NodeFilter.FILTER_REJECT) {
      let w = p.nextNode();
      for (; w != null; )
        c(w), w = p.nextNode();
    }
  }, c = (h) => {
    let g = Le.get(h) ?? 0;
    h.getAttribute("aria-hidden") === "true" && g === 0 || (g === 0 && h.setAttribute("aria-hidden", "true"), a.add(h), Le.set(h, g + 1));
  };
  G.length && G[G.length - 1].disconnect(), l(f);
  const u = new o.MutationObserver((h) => {
    for (let g of h)
      if (!(g.type !== "childList" || g.addedNodes.length === 0) && ![...s, ...a].some((p) => p.contains(g.target))) {
        for (let p of g.removedNodes)
          p instanceof o.Element && (s.delete(p), a.delete(p));
        for (let p of g.addedNodes)
          (p instanceof o.HTMLElement || p instanceof o.SVGElement) && (p.dataset.liveAnnouncer === "true" || p.dataset.zagTopLayer === "true") ? s.add(p) : p instanceof o.Element && l(p);
      }
  });
  u.observe(f, { childList: !0, subtree: !0 });
  let d = {
    observe() {
      u.observe(f, { childList: !0, subtree: !0 });
    },
    disconnect() {
      u.disconnect();
    }
  };
  return G.push(d), () => {
    u.disconnect();
    for (let h of a) {
      let g = Le.get(h);
      g === 1 ? (h.removeAttribute("aria-hidden"), Le.delete(h)) : Le.set(h, g - 1);
    }
    d === G[G.length - 1] ? (G.pop(), G.length && G[G.length - 1].observe()) : G.splice(G.indexOf(d), 1);
  };
}
function os(e, t = {}) {
  const { defer: n } = t, r = n ? Ke : (o) => o(), i = [];
  return i.push(
    r(() => {
      const o = typeof e == "function" ? e() : e;
      i.push(is(o, t));
    })
  ), () => {
    i.forEach((o) => o == null ? void 0 : o());
  };
}
var Ft = "data-zag-scroll-lock";
function Fn(e, t) {
  if (!e)
    return;
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function ss(e, t, n) {
  if (!e)
    return;
  const r = e.style.getPropertyValue(t);
  return e.style.setProperty(t, n), () => {
    r ? e.style.setProperty(t, r) : e.style.removeProperty(t);
  };
}
function as(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function ls(e) {
  const t = e ?? document, n = t.defaultView ?? window, { documentElement: r, body: i } = t;
  if (i.hasAttribute(Ft))
    return;
  i.setAttribute(Ft, "");
  const s = n.innerWidth - r.clientWidth, a = () => ss(r, "--scrollbar-width", `${s}px`), f = as(r), l = () => Fn(i, {
    overflow: "hidden",
    [f]: `${s}px`
  }), c = () => {
    const { scrollX: d, scrollY: h, visualViewport: g } = n, p = (g == null ? void 0 : g.offsetLeft) ?? 0, P = (g == null ? void 0 : g.offsetTop) ?? 0, w = Fn(i, {
      position: "fixed",
      overflow: "hidden",
      top: `${-(h - Math.floor(P))}px`,
      left: `${-(d - Math.floor(p))}px`,
      right: "0",
      [f]: `${s}px`
    });
    return () => {
      w == null || w(), n.scrollTo({ left: d, top: h, behavior: "instant" });
    };
  }, u = [a(), Io() ? c() : l()];
  return () => {
    u.forEach((d) => d == null ? void 0 : d()), i.removeAttribute(Ft);
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var wr = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], ut = /* @__PURE__ */ wr.join(","), Er = typeof Element > "u", ge = Er ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, dt = !Er && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ft = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), o = i === "" || i === "true", s = o || n && t && e(t.parentNode);
  return s;
}, cs = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Pr = function(t, n, r) {
  if (ft(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(ut));
  return n && ge.call(t, ut) && i.unshift(t), i = i.filter(r), i;
}, Sr = function e(t, n, r) {
  for (var i = [], o = Array.from(t); o.length; ) {
    var s = o.shift();
    if (!ft(s, !1))
      if (s.tagName === "SLOT") {
        var a = s.assignedElements(), f = a.length ? a : s.children, l = e(f, !0, r);
        r.flatten ? i.push.apply(i, l) : i.push({
          scopeParent: s,
          candidates: l
        });
      } else {
        var c = ge.call(s, ut);
        c && r.filter(s) && (n || !t.includes(s)) && i.push(s);
        var u = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), d = !ft(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (u && d) {
          var h = e(u === !0 ? s.children : u.children, !0, r);
          r.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: s,
            candidates: h
          });
        } else
          o.unshift.apply(o, s.children);
      }
  }
  return i;
}, Cr = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pe = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || cs(t)) && !Cr(t) ? 0 : t.tabIndex;
}, us = function(t, n) {
  var r = pe(t);
  return r < 0 && n && !Cr(t) ? 0 : r;
}, ds = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Or = function(t) {
  return t.tagName === "INPUT";
}, fs = function(t) {
  return Or(t) && t.type === "hidden";
}, hs = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, ps = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, gs = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || dt(t), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var o = ps(i, t.form);
  return !o || o === t;
}, ys = function(t) {
  return Or(t) && t.type === "radio";
}, vs = function(t) {
  return ys(t) && !gs(t);
}, bs = function(t) {
  var n, r = t && dt(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, o = !1;
  if (r && r !== t) {
    var s, a, f;
    for (o = !!((s = i) !== null && s !== void 0 && (a = s.ownerDocument) !== null && a !== void 0 && a.contains(i) || t != null && (f = t.ownerDocument) !== null && f !== void 0 && f.contains(t)); !o && i; ) {
      var l, c, u;
      r = dt(i), i = (l = r) === null || l === void 0 ? void 0 : l.host, o = !!((c = i) !== null && c !== void 0 && (u = c.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return o;
}, _n = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, ms = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var o = ge.call(t, "details>summary:first-of-type"), s = o ? t.parentElement : t;
  if (ge.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var a = t; t; ) {
        var f = t.parentElement, l = dt(t);
        if (f && !f.shadowRoot && i(f) === !0)
          return _n(t);
        t.assignedSlot ? t = t.assignedSlot : !f && l !== t.ownerDocument ? t = l.host : t = f;
      }
      t = a;
    }
    if (bs(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return _n(t);
  return !1;
}, ws = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return ge.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ht = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  ft(n) || fs(n) || ms(n, t) || // For a details element with a summary, the summary element gets the focus
  hs(n) || ws(n));
}, qt = function(t, n) {
  return !(vs(n) || pe(n) < 0 || !ht(t, n));
}, Es = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ps = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, o) {
    var s = !!i.scopeParent, a = s ? i.scopeParent : i, f = us(a, s), l = s ? e(i.candidates) : a;
    f === 0 ? s ? n.push.apply(n, l) : n.push(a) : r.push({
      documentOrder: o,
      tabIndex: f,
      item: i,
      isScope: s,
      content: l
    });
  }), r.sort(ds).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(n);
}, Ss = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Sr([t], n.includeContainer, {
    filter: qt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Es
  }) : r = Pr(t, n.includeContainer, qt.bind(null, n)), Ps(r);
}, Cs = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Sr([t], n.includeContainer, {
    filter: ht.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Pr(t, n.includeContainer, ht.bind(null, n)), r;
}, be = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ge.call(t, ut) === !1 ? !1 : qt(n, t);
}, Os = /* @__PURE__ */ wr.concat("iframe").join(","), _t = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return ge.call(t, Os) === !1 ? !1 : ht(n, t);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function In(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? In(Object(n), !0).forEach(function(r) {
      xs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : In(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xs(e, t, n) {
  return t = Ns(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function As(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ns(e) {
  var t = As(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Rn = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r.pause();
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, Ts = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, ks = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, je = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, Ds = function(t) {
  return je(t) && !t.shiftKey;
}, Ls = function(t) {
  return je(t) && t.shiftKey;
}, Mn = function(t) {
  return setTimeout(t, 0);
}, Bn = function(t, n) {
  var r = -1;
  return t.every(function(i, o) {
    return n(i) ? (r = o, !1) : !0;
  }), r;
}, $e = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, qe = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, $s = [], Fs = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || $s, o = jn({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Ds,
    isKeyBackward: Ls
  }, n), s = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, a, f = function(y, v, m) {
    return y && y[v] !== void 0 ? y[v] : o[m || v];
  }, l = function(y, v) {
    var m = typeof (v == null ? void 0 : v.composedPath) == "function" ? v.composedPath() : void 0;
    return s.containerGroups.findIndex(function(A) {
      var x = A.container, k = A.tabbableNodes;
      return x.contains(y) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (m == null ? void 0 : m.includes(x)) || k.find(function(R) {
        return R === y;
      });
    });
  }, c = function(y) {
    var v = o[y];
    if (typeof v == "function") {
      for (var m = arguments.length, A = new Array(m > 1 ? m - 1 : 0), x = 1; x < m; x++)
        A[x - 1] = arguments[x];
      v = v.apply(void 0, A);
    }
    if (v === !0 && (v = void 0), !v) {
      if (v === void 0 || v === !1)
        return v;
      throw new Error("`".concat(y, "` was specified but was not a node, or did not return a node"));
    }
    var k = v;
    if (typeof v == "string" && (k = r.querySelector(v), !k))
      throw new Error("`".concat(y, "` as selector refers to no known node"));
    return k;
  }, u = function() {
    var y = c("initialFocus");
    if (y === !1)
      return !1;
    if (y === void 0 || !_t(y, o.tabbableOptions))
      if (l(r.activeElement) >= 0)
        y = r.activeElement;
      else {
        var v = s.tabbableGroups[0], m = v && v.firstTabbableNode;
        y = m || c("fallbackFocus");
      }
    if (!y)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return y;
  }, d = function() {
    if (s.containerGroups = s.containers.map(function(y) {
      var v = Ss(y, o.tabbableOptions), m = Cs(y, o.tabbableOptions), A = v.length > 0 ? v[0] : void 0, x = v.length > 0 ? v[v.length - 1] : void 0, k = m.find(function(B) {
        return be(B);
      }), R = m.slice().reverse().find(function(B) {
        return be(B);
      }), W = !!v.find(function(B) {
        return pe(B) > 0;
      });
      return {
        container: y,
        tabbableNodes: v,
        focusableNodes: m,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: W,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: A,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: x,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: k,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: R,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(de) {
          var Ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, se = v.indexOf(de);
          return se < 0 ? Ne ? m.slice(m.indexOf(de) + 1).find(function(Te) {
            return be(Te);
          }) : m.slice(0, m.indexOf(de)).reverse().find(function(Te) {
            return be(Te);
          }) : v[se + (Ne ? 1 : -1)];
        }
      };
    }), s.tabbableGroups = s.containerGroups.filter(function(y) {
      return y.tabbableNodes.length > 0;
    }), s.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (s.containerGroups.find(function(y) {
      return y.posTabIndexesFound;
    }) && s.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function b(y) {
    var v = y.activeElement;
    if (v)
      return v.shadowRoot && v.shadowRoot.activeElement !== null ? b(v.shadowRoot) : v;
  }, g = function b(y) {
    if (y !== !1 && y !== h(document)) {
      if (!y || !y.focus) {
        b(u());
        return;
      }
      y.focus({
        preventScroll: !!o.preventScroll
      }), s.mostRecentlyFocusedNode = y, Ts(y) && y.select();
    }
  }, p = function(y) {
    var v = c("setReturnFocus", y);
    return v || (v === !1 ? !1 : y);
  }, P = function(y) {
    var v = y.target, m = y.event, A = y.isBackward, x = A === void 0 ? !1 : A;
    v = v || qe(m), d();
    var k = null;
    if (s.tabbableGroups.length > 0) {
      var R = l(v, m), W = R >= 0 ? s.containerGroups[R] : void 0;
      if (R < 0)
        x ? k = s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode : k = s.tabbableGroups[0].firstTabbableNode;
      else if (x) {
        var B = Bn(s.tabbableGroups, function(Et) {
          var Pt = Et.firstTabbableNode;
          return v === Pt;
        });
        if (B < 0 && (W.container === v || _t(v, o.tabbableOptions) && !be(v, o.tabbableOptions) && !W.nextTabbableNode(v, !1)) && (B = R), B >= 0) {
          var de = B === 0 ? s.tabbableGroups.length - 1 : B - 1, Ne = s.tabbableGroups[de];
          k = pe(v) >= 0 ? Ne.lastTabbableNode : Ne.lastDomTabbableNode;
        } else
          je(m) || (k = W.nextTabbableNode(v, !1));
      } else {
        var se = Bn(s.tabbableGroups, function(Et) {
          var Pt = Et.lastTabbableNode;
          return v === Pt;
        });
        if (se < 0 && (W.container === v || _t(v, o.tabbableOptions) && !be(v, o.tabbableOptions) && !W.nextTabbableNode(v)) && (se = R), se >= 0) {
          var Te = se === s.tabbableGroups.length - 1 ? 0 : se + 1, cn = s.tabbableGroups[Te];
          k = pe(v) >= 0 ? cn.firstTabbableNode : cn.firstDomTabbableNode;
        } else
          je(m) || (k = W.nextTabbableNode(v));
      }
    } else
      k = c("fallbackFocus");
    return k;
  }, w = function(y) {
    var v = qe(y);
    if (!(l(v, y) >= 0)) {
      if ($e(o.clickOutsideDeactivates, y)) {
        a.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: o.returnFocusOnDeactivate
        });
        return;
      }
      $e(o.allowOutsideClick, y) || y.preventDefault();
    }
  }, N = function(y) {
    var v = qe(y), m = l(v, y) >= 0;
    if (m || v instanceof Document)
      m && (s.mostRecentlyFocusedNode = v);
    else {
      y.stopImmediatePropagation();
      var A, x = !0;
      if (s.mostRecentlyFocusedNode)
        if (pe(s.mostRecentlyFocusedNode) > 0) {
          var k = l(s.mostRecentlyFocusedNode), R = s.containerGroups[k].tabbableNodes;
          if (R.length > 0) {
            var W = R.findIndex(function(B) {
              return B === s.mostRecentlyFocusedNode;
            });
            W >= 0 && (o.isKeyForward(s.recentNavEvent) ? W + 1 < R.length && (A = R[W + 1], x = !1) : W - 1 >= 0 && (A = R[W - 1], x = !1));
          }
        } else
          s.containerGroups.some(function(B) {
            return B.tabbableNodes.some(function(de) {
              return pe(de) > 0;
            });
          }) || (x = !1);
      else
        x = !1;
      x && (A = P({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: s.mostRecentlyFocusedNode,
        isBackward: o.isKeyBackward(s.recentNavEvent)
      })), g(A || s.mostRecentlyFocusedNode || u());
    }
    s.recentNavEvent = void 0;
  }, $ = function(y) {
    var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    s.recentNavEvent = y;
    var m = P({
      event: y,
      isBackward: v
    });
    m && (je(y) && y.preventDefault(), g(m));
  }, I = function(y) {
    if (ks(y) && $e(o.escapeDeactivates, y) !== !1) {
      y.preventDefault(), a.deactivate();
      return;
    }
    (o.isKeyForward(y) || o.isKeyBackward(y)) && $(y, o.isKeyBackward(y));
  }, z = function(y) {
    var v = qe(y);
    l(v, y) >= 0 || $e(o.clickOutsideDeactivates, y) || $e(o.allowOutsideClick, y) || (y.preventDefault(), y.stopImmediatePropagation());
  }, ne = function() {
    if (s.active)
      return Rn.activateTrap(i, a), s.delayInitialFocusTimer = o.delayInitialFocus ? Mn(function() {
        g(u());
      }) : g(u()), r.addEventListener("focusin", N, !0), r.addEventListener("mousedown", w, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", w, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", z, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I, {
        capture: !0,
        passive: !1
      }), a;
  }, T = function() {
    if (s.active)
      return r.removeEventListener("focusin", N, !0), r.removeEventListener("mousedown", w, !0), r.removeEventListener("touchstart", w, !0), r.removeEventListener("click", z, !0), r.removeEventListener("keydown", I, !0), a;
  }, j = function(y) {
    var v = y.some(function(m) {
      var A = Array.from(m.removedNodes);
      return A.some(function(x) {
        return x === s.mostRecentlyFocusedNode;
      });
    });
    v && g(u());
  }, C = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(j) : void 0, S = function() {
    C && (C.disconnect(), s.active && !s.paused && s.containers.map(function(y) {
      C.observe(y, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return a = {
    get active() {
      return s.active;
    },
    get paused() {
      return s.paused;
    },
    activate: function(y) {
      if (s.active)
        return this;
      var v = f(y, "onActivate"), m = f(y, "onPostActivate"), A = f(y, "checkCanFocusTrap");
      A || d(), s.active = !0, s.paused = !1, s.nodeFocusedBeforeActivation = r.activeElement, v == null || v();
      var x = function() {
        A && d(), ne(), S(), m == null || m();
      };
      return A ? (A(s.containers.concat()).then(x, x), this) : (x(), this);
    },
    deactivate: function(y) {
      if (!s.active)
        return this;
      var v = jn({
        onDeactivate: o.onDeactivate,
        onPostDeactivate: o.onPostDeactivate,
        checkCanReturnFocus: o.checkCanReturnFocus
      }, y);
      clearTimeout(s.delayInitialFocusTimer), s.delayInitialFocusTimer = void 0, T(), s.active = !1, s.paused = !1, S(), Rn.deactivateTrap(i, a);
      var m = f(v, "onDeactivate"), A = f(v, "onPostDeactivate"), x = f(v, "checkCanReturnFocus"), k = f(v, "returnFocus", "returnFocusOnDeactivate");
      m == null || m();
      var R = function() {
        Mn(function() {
          k && g(p(s.nodeFocusedBeforeActivation)), A == null || A();
        });
      };
      return k && x ? (x(p(s.nodeFocusedBeforeActivation)).then(R, R), this) : (R(), this);
    },
    pause: function(y) {
      if (s.paused || !s.active)
        return this;
      var v = f(y, "onPause"), m = f(y, "onPostPause");
      return s.paused = !0, v == null || v(), T(), S(), m == null || m(), this;
    },
    unpause: function(y) {
      if (!s.paused || !s.active)
        return this;
      var v = f(y, "onUnpause"), m = f(y, "onPostUnpause");
      return s.paused = !1, v == null || v(), d(), ne(), S(), m == null || m(), this;
    },
    updateContainerElements: function(y) {
      var v = [].concat(y).filter(Boolean);
      return s.containers = v.map(function(m) {
        return typeof m == "string" ? r.querySelector(m) : m;
      }), s.active && d(), S(), this;
    }
  }, a.updateContainerElements(t), a;
}, _s = Ze("dialog").parts(
  "trigger",
  "backdrop",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
), fe = _s.build(), D = Ro({
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `dialog:${e.id}:positioner`;
  },
  getBackdropId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.backdrop) ?? `dialog:${e.id}:backdrop`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `dialog:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `dialog:${e.id}:trigger`;
  },
  getTitleId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.title) ?? `dialog:${e.id}:title`;
  },
  getDescriptionId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.description) ?? `dialog:${e.id}:description`;
  },
  getCloseTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.closeTrigger) ?? `dialog:${e.id}:close`;
  },
  getContentEl: (e) => D.getById(e, D.getContentId(e)),
  getTriggerEl: (e) => D.getById(e, D.getTriggerId(e)),
  getTitleEl: (e) => D.getById(e, D.getTitleId(e)),
  getDescriptionEl: (e) => D.getById(e, D.getDescriptionId(e))
});
function Is(e, t, n) {
  const r = e.context["aria-label"], i = e.matches("open"), o = e.context.renderedElements;
  return {
    isOpen: i,
    open() {
      t("OPEN");
    },
    close() {
      t("CLOSE");
    },
    triggerProps: n.button({
      ...fe.trigger.attrs,
      dir: e.context.dir,
      id: D.getTriggerId(e.context),
      "aria-haspopup": "dialog",
      type: "button",
      "aria-expanded": i,
      "data-state": i ? "open" : "closed",
      "aria-controls": D.getContentId(e.context),
      onClick() {
        t("TOGGLE");
      }
    }),
    backdropProps: n.element({
      ...fe.backdrop.attrs,
      dir: e.context.dir,
      hidden: !i,
      id: D.getBackdropId(e.context),
      "data-state": i ? "open" : "closed"
    }),
    positionerProps: n.element({
      ...fe.positioner.attrs,
      dir: e.context.dir,
      id: D.getPositionerId(e.context),
      style: {
        pointerEvents: i ? void 0 : "none"
      }
    }),
    contentProps: n.element({
      ...fe.content.attrs,
      dir: e.context.dir,
      role: e.context.role,
      hidden: !i,
      id: D.getContentId(e.context),
      tabIndex: -1,
      "data-state": i ? "open" : "closed",
      "aria-modal": !0,
      "aria-label": r || void 0,
      "aria-labelledby": r || !o.title ? void 0 : D.getTitleId(e.context),
      "aria-describedby": o.description ? D.getDescriptionId(e.context) : void 0
    }),
    titleProps: n.element({
      ...fe.title.attrs,
      dir: e.context.dir,
      id: D.getTitleId(e.context)
    }),
    descriptionProps: n.element({
      ...fe.description.attrs,
      dir: e.context.dir,
      id: D.getDescriptionId(e.context)
    }),
    closeTriggerProps: n.button({
      ...fe.closeTrigger.attrs,
      dir: e.context.dir,
      id: D.getCloseTriggerId(e.context),
      type: "button",
      onClick(s) {
        s.stopPropagation(), t("CLOSE");
      }
    })
  };
}
function js(e) {
  const t = vr(e);
  return dr(
    {
      id: "dialog",
      initial: t.open ? "open" : "closed",
      context: {
        role: "dialog",
        renderedElements: {
          title: !0,
          description: !0
        },
        modal: !0,
        trapFocus: !0,
        preventScroll: !0,
        closeOnInteractOutside: !0,
        closeOnEscapeKeyDown: !0,
        restoreFocus: !0,
        ...t
      },
      watch: {
        open: ["toggleVisibility"]
      },
      states: {
        open: {
          entry: ["checkRenderedElements"],
          activities: ["trackDismissableElement", "trapFocus", "preventScroll", "hideContentBelow"],
          on: {
            "CONTROLLED.CLOSE": {
              target: "closed",
              actions: ["restoreFocus"]
            },
            CLOSE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closed",
                actions: ["invokeOnClose", "restoreFocus"]
              }
            ],
            TOGGLE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnClose"]
              },
              {
                target: "closed",
                actions: ["invokeOnClose", "restoreFocus"]
              }
            ]
          }
        },
        closed: {
          on: {
            "CONTROLLED.OPEN": {
              target: "open"
            },
            OPEN: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ],
            TOGGLE: [
              {
                guard: "isOpenControlled",
                actions: ["invokeOnOpen"]
              },
              {
                target: "open",
                actions: ["invokeOnOpen"]
              }
            ]
          }
        }
      }
    },
    {
      guards: {
        isOpenControlled: (n) => !!n["open.controlled"]
      },
      activities: {
        trackDismissableElement(n, r, { send: i }) {
          return rs(() => D.getContentEl(n), {
            defer: !0,
            pointerBlocking: n.modal,
            exclude: [D.getTriggerEl(n)],
            onEscapeKeyDown(s) {
              var a;
              n.closeOnEscapeKeyDown ? i({ type: "CLOSE", src: "escape-key" }) : s.preventDefault(), (a = n.onEscapeKeyDown) == null || a.call(n, s);
            },
            onPointerDownOutside(s) {
              var a;
              n.closeOnInteractOutside || s.preventDefault(), (a = n.onPointerDownOutside) == null || a.call(n, s);
            },
            onFocusOutside(s) {
              var a;
              n.closeOnInteractOutside || s.preventDefault(), (a = n.onFocusOutside) == null || a.call(n, s);
            },
            onDismiss() {
              i({ type: "CLOSE", src: "interact-outside" });
            }
          });
        },
        preventScroll(n) {
          if (n.preventScroll)
            return ls(D.getDoc(n));
        },
        trapFocus(n) {
          if (!n.trapFocus || !n.modal)
            return;
          let r;
          return jo(() => {
            const i = D.getContentEl(n);
            if (i) {
              r = Fs(i, {
                document: D.getDoc(n),
                escapeDeactivates: !1,
                preventScroll: !0,
                returnFocusOnDeactivate: !1,
                fallbackFocus: i,
                allowOutsideClick: !0,
                initialFocus: Nn(n.initialFocusEl)
              });
              try {
                r.activate();
              } catch {
              }
            }
          }), () => r == null ? void 0 : r.deactivate();
        },
        hideContentBelow(n) {
          return n.modal ? os(() => [D.getContentEl(n)], { defer: !0 }) : void 0;
        }
      },
      actions: {
        checkRenderedElements(n) {
          Ke(() => {
            n.renderedElements.title = !!D.getTitleEl(n), n.renderedElements.description = !!D.getDescriptionEl(n);
          });
        },
        invokeOnClose(n) {
          var r;
          (r = n.onOpenChange) == null || r.call(n, { open: !1 });
        },
        invokeOnOpen(n) {
          var r;
          (r = n.onOpenChange) == null || r.call(n, { open: !0 });
        },
        toggleVisibility(n, r, { send: i }) {
          i({ type: n.open ? "CONTROLLED.OPEN" : "CONTROLLED.CLOSE", previousEvent: r });
        },
        restoreFocus(n) {
          n.restoreFocus && Ke(() => {
            const r = Nn(n.finalFocusEl) ?? D.getTriggerEl(n);
            r == null || r.focus({ preventScroll: !0 });
          });
        }
      }
    }
  );
}
tr()([
  "aria-label",
  "closeOnEscapeKeyDown",
  "closeOnInteractOutside",
  "dir",
  "finalFocusEl",
  "getRootNode",
  "getRootNode",
  "id",
  "id",
  "ids",
  "initialFocusEl",
  "modal",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "open.controlled",
  "open",
  "preventScroll",
  "restoreFocus",
  "role",
  "trapFocus"
]);
const [Rs, Ve] = bt({
  hookName: "useDialogContext",
  providerName: "<DialogProvider />"
}), Ms = (e) => {
  const t = Ve(), n = Oo(), r = hr(ce(n, () => ({
    present: t().isOpen
  }))), i = ce(() => t().backdropProps, () => r().presenceProps, e);
  return O(Pe, {
    get when() {
      return !r().isUnmounted;
    },
    get children() {
      return O(We.div, i);
    }
  });
}, Bs = (e) => {
  const t = Ve(), n = pr(), r = ce(() => t().contentProps, () => n().presenceProps, e);
  return O(Pe, {
    get when() {
      return !n().isUnmounted;
    },
    get children() {
      return O(We.div, r);
    }
  });
}, Ks = (e) => {
  const t = Ve(), n = ce(() => t().descriptionProps, e);
  return O(We.div, n);
}, zs = (e) => {
  const t = Ve(), n = pr(), r = ce(() => t().positionerProps, e);
  return O(Pe, {
    get when() {
      return !n().isUnmounted;
    },
    get children() {
      return O(We.div, r);
    }
  });
}, Ws = (e) => {
  const t = Wo(), n = ce({ id: Zr(), getRootNode: t }, e), [r, i] = ar(js(n), { context: n });
  return V(() => Is(r, i, Vi));
}, Vs = (e) => {
  const [t, n] = Xi(e), [r] = fr(t), [i, o] = rn()(n, ["aria-label", "closeOnEscapeKeyDown", "closeOnInteractOutside", "dir", "finalFocusEl", "getRootNode", "id", "ids", "initialFocusEl", "modal", "onEscapeKeyDown", "onFocusOutside", "onInteractOutside", "onOpenChange", "onPointerDownOutside", "open", "preventScroll", "restoreFocus", "role", "trapFocus"]), s = Ws(i), a = hr(ce(t, () => ({
    present: s().isOpen
  }))), f = () => No(o.children, s);
  return O(Rs, {
    value: s,
    get children() {
      return O(Co, {
        value: r,
        get children() {
          return O(xo, {
            value: a,
            get children() {
              return f();
            }
          });
        }
      });
    }
  });
}, Us = (e) => {
  const t = Ve(), n = ce(() => t().titleProps, e);
  return O(We.h2, n);
}, Xt = "sats-connect_wallet-provider-selector_select", Yt = "sats-connect_wallet-provider-selector_cancel", Ht = "sats-connect_wallet-provider-selector_open", Zt = "sats-connect_wallet-provider-selector_close", xr = "sats-connect_wallet-provider-selector_walletOpen", Ar = "sats-connect_wallet-provider-selector_walletClose", wt = {
  color: "#181818",
  "font-size": "18px",
  "font-weight": "700",
  "line-height": "1.4"
}, xe = {
  color: "#181818",
  "font-size": "14px",
  "font-weight": "400",
  "line-height": "1.4"
}, Gs = {
  color: "#181818",
  "font-size": "14px",
  "font-weight": "500"
};
var qs = /* @__PURE__ */ M('<svg width=24 height=24 viewBox="0 0 24 24"fill=none xmlns=http://www.w3.org/2000/svg><g id=XCircle><path id=Vector d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.745 9.41566 20.7162 6.93859 18.8888 5.11118C17.0614 3.28378 14.5843 2.25496 12 2.25ZM15.5344 14.4656C15.6752 14.6078 15.7542 14.7999 15.7542 15C15.7542 15.2001 15.6752 15.3922 15.5344 15.5344C15.391 15.673 15.1994 15.7505 15 15.7505C14.8006 15.7505 14.609 15.673 14.4656 15.5344L12 13.0594L9.53438 15.5344C9.39102 15.673 9.19942 15.7505 9 15.7505C8.80059 15.7505 8.60898 15.673 8.46563 15.5344C8.32479 15.3922 8.24578 15.2001 8.24578 15C8.24578 14.7999 8.32479 14.6078 8.46563 14.4656L10.9406 12L8.46563 9.53437C8.34603 9.38865 8.28491 9.20366 8.29416 9.01537C8.30341 8.82708 8.38236 8.64896 8.51566 8.51566C8.64896 8.38236 8.82708 8.3034 9.01537 8.29416C9.20366 8.28491 9.38866 8.34603 9.53438 8.46563L12 10.9406L14.4656 8.46563C14.6114 8.34603 14.7963 8.28491 14.9846 8.29416C15.1729 8.3034 15.351 8.38236 15.4843 8.51566C15.6176 8.64896 15.6966 8.82708 15.7058 9.01537C15.7151 9.20366 15.654 9.38865 15.5344 9.53437L13.0594 12L15.5344 14.4656Z"fill=black fill-opacity=0.3>'), Xs = /* @__PURE__ */ M(`<style>
          .close-selector-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: -0.25px;
          }
        `), Ys = /* @__PURE__ */ M("<div role=button tabindex=0 class=close-selector-button>");
function Hs(e) {
  return (() => {
    var t = qs();
    return t.style.setProperty("display", "block"), er(t, e, !0, !0), t;
  })();
}
function Zs(e) {
  function t(n) {
    (n.key === "Enter" || n.key === " ") && e.onClose();
  }
  return [Xs(), (() => {
    var n = Ys();
    return n.$$keydown = t, Qn(n, "click", e.onClose, !0), n.style.setProperty("position", "absolute"), n.style.setProperty("top", "16px"), n.style.setProperty("right", "16px"), n.style.setProperty("background", "none"), n.style.setProperty("border", "none"), n.style.setProperty("cursor", "pointer"), n.style.setProperty("padding", "0"), n.style.setProperty("margin", "0"), n.style.setProperty("border-radius", "50%"), _(n, O(Hs, {})), n;
  })()];
}
vt(["click", "keydown"]);
var Js = /* @__PURE__ */ M(`<style>
/*! modern-normalize v2.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*
Document
========
*/

/**
Use a better box model (opinionated).
*/

*,
::before,
::after {
	box-sizing: border-box;
	margin: 0; /* Remove all margins from everywhere. */
}

:host {
	/* Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3) */
	font-family:
		'DM Sans', /* Note: not part of modern-normalize, added specifically for this project. */
		system-ui,
		'Segoe UI',
		Roboto,
		Helvetica,
		Arial,
		sans-serif,
		'Apple Color Emoji',
		'Segoe UI Emoji';
	line-height: 1.15; /* 1. Correct the line height in all browsers. */
	-webkit-text-size-adjust: 100%; /* 2. Prevent adjustments of font size after orientation changes in iOS. */
	-moz-tab-size: 4; /* 3. Use a more readable tab size (opinionated). */
	tab-size: 4; /* 3 */
}

/*
Sections
========
*/

:host {
	margin: 0; /* Remove the margin in all browsers. */
}

/*
Grouping content
================
*/

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/

hr {
	height: 0; /* 1 */
	color: inherit; /* 2 */
}

/*
Text-level semantics
====================
*/

/**
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr[title] {
	text-decoration: underline dotted;
}

/**
Add the correct font weight in Edge and Safari.
*/

b,
strong {
	font-weight: bolder;
}

/**
1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
2. Correct the odd 'em' font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
	font-family:
		ui-monospace,
		SFMono-Regular,
		Consolas,
		'Liberation Mono',
		Menlo,
		monospace; /* 1 */
	font-size: 1em; /* 2 */
}

/**
Add the correct font size in all browsers.
*/

small {
	font-size: 80%;
}

/**
Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
*/

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

/*
Tabular data
============
*/

/**
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
*/

table {
	text-indent: 0; /* 1 */
	border-color: inherit; /* 2 */
}

/*
Forms
=====
*/

/**
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
*/

button,
input,
optgroup,
select,
textarea {
	font-family: inherit; /* 1 */
	font-size: 100%; /* 1 */
	line-height: 1.15; /* 1 */
	margin: 0; /* 2 */
}

/**
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
	text-transform: none;
}

/**
Correct the inability to style clickable types in iOS and Safari.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}

/**
Remove the inner border and padding in Firefox.
*/

::-moz-focus-inner {
	border-style: none;
	padding: 0;
}

/**
Restore the focus styles unset by the previous rule.
*/

:-moz-focusring {
	outline: 1px dotted ButtonText;
}

/**
Remove the additional ':invalid' styles in Firefox.
See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
*/

:-moz-ui-invalid {
	box-shadow: none;
}

/**
Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
*/

legend {
	padding: 0;
}

/**
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
	vertical-align: baseline;
}

/**
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

/**
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
	-webkit-appearance: textfield; /* 1 */
	outline-offset: -2px; /* 2 */
}

/**
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
	-webkit-appearance: none;
}

/**
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to 'inherit' in Safari.
*/

::-webkit-file-upload-button {
	-webkit-appearance: button; /* 1 */
	font: inherit; /* 2 */
}

/*
Interactive
===========
*/

/*
Add the correct display in Chrome and Safari.
*/

summary {
	display: list-item;
}
`);
function Qs() {
  return Js();
}
var ea = /* @__PURE__ */ M("<div class=divider><div>");
function ta() {
  return (() => {
    var e = ea(), t = e.firstChild;
    return t.style.setProperty("height", "100%"), t.style.setProperty("width", "1px"), t.style.setProperty("background", "#dcdcdc"), e;
  })();
}
var na = /* @__PURE__ */ M("<div>");
function ra(e) {
  return (() => {
    var t = na();
    return t.style.setProperty("padding", "24px"), t.style.setProperty("height", "100%"), _(t, () => e.children), t;
  })();
}
var ia = /* @__PURE__ */ M("<div>");
function oa(e) {
  return (() => {
    var t = ia();
    return t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("justify-content", "center"), t.style.setProperty("align-items", "center"), t.style.setProperty("height", "100%"), _(t, () => e.children), t;
  })();
}
var sa = /* @__PURE__ */ M("<div><div>🤔</div><div>What is a wallet?</div><p>Wallets let you send, receive, store and display digital assets like Bitcoin, Stacks, Ordinals & NFTs.</p><p>Explore Bitcoin apps by connecting your wallet.");
function aa() {
  return (() => {
    var e = sa(), t = e.firstChild, n = t.nextSibling, r = n.nextSibling, i = r.nextSibling;
    return e.style.setProperty("display", "flex"), e.style.setProperty("flex-direction", "column"), e.style.setProperty("row-gap", "8px"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), t.style.setProperty("font-size", "50px"), t.style.setProperty("line-height", "140%"), Y((o) => {
      var s = wt, a = xe, f = xe;
      return o.e = te(n, s, o.e), o.t = te(r, a, o.t), o.a = te(i, f, o.a), o;
    }, {
      e: void 0,
      t: void 0,
      a: void 0
    }), e;
  })();
}
function Jt(e) {
  var n;
  const t = (n = e.installPrompt) == null ? void 0 : n.url;
  if (!t) {
    console.error("No install prompt URL found for", e.id);
    return;
  }
  window.open(t, "_blank");
}
var la = /* @__PURE__ */ M(`<style>
          .install-prompt-button:focus-visible {
            outline: 2px solid #181818;
            outline-offset: 2px;
          }
        `), ca = /* @__PURE__ */ M("<div><img><h1>Don't have <!>?</h1><p>Download it on the Chrome web store.</p><div class=install-prompt-button role=button tabindex=0>Get");
function ua(e) {
  function t(r) {
    (r.key === "Enter" || r.key === " ") && Jt(e.option);
  }
  function n() {
    Jt(e.option);
  }
  return [la(), (() => {
    var r = ca(), i = r.firstChild, o = i.nextSibling, s = o.firstChild, a = s.nextSibling;
    a.nextSibling;
    var f = o.nextSibling, l = f.nextSibling;
    return r.style.setProperty("display", "flex"), r.style.setProperty("flex-direction", "column"), r.style.setProperty("align-items", "center"), r.style.setProperty("row-gap", "16px"), i.style.setProperty("border-radius", "12px"), i.style.setProperty("height", "64px"), i.style.setProperty("width", "64px"), i.style.setProperty("object-fit", "cover"), _(o, () => e.option.name, a), l.$$keydown = t, l.$$click = n, Y((c) => {
      var u = e.option.icon, d = e.option.name, h = {
        ...wt,
        "text-align": "center"
      }, g = xe, p = {
        ...Gs,
        cursor: "pointer",
        "border-radius": "12px",
        background: "#181818",
        color: "white",
        padding: "12px 16px"
      };
      return u !== c.e && ee(i, "src", c.e = u), d !== c.t && ee(i, "alt", c.t = d), c.a = te(o, h, c.a), c.o = te(f, g, c.o), c.i = te(l, p, c.i), c;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), r;
  })()];
}
vt(["click", "keydown"]);
var da = /* @__PURE__ */ M('<svg width=20 height=20 viewBox="0 0 20 20"xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=9.05 stroke=black stroke-width=1.9 fill=none stroke-dasharray="42.65 14.22"stroke-dashoffset=0><animateTransform attributeName=transform attributeType=XML type=rotate from="0 10 10"to="360 10 10"dur=0.75s repeatCount=indefinite>'), fa = /* @__PURE__ */ M("<div>");
const ha = () => da();
function pa() {
  return (() => {
    var e = fa();
    return e.style.setProperty("display", "flex"), e.style.setProperty("justify-content", "center"), e.style.setProperty("align-items", "center"), e.style.setProperty("height", "100%"), e.style.setProperty("animation", "spin 1s linear infinite"), _(e, O(ha, {})), e;
  })();
}
var ga = /* @__PURE__ */ M("<div><img><h1>Opening <!>...</h1><p>Confirm the operation in ");
function ya(e) {
  return (() => {
    var t = ga(), n = t.firstChild, r = n.nextSibling, i = r.firstChild, o = i.nextSibling;
    o.nextSibling;
    var s = r.nextSibling;
    return s.firstChild, t.style.setProperty("display", "flex"), t.style.setProperty("flex-direction", "column"), t.style.setProperty("align-items", "center"), t.style.setProperty("row-gap", "16px"), n.style.setProperty("border-radius", "12px"), n.style.setProperty("height", "64px"), n.style.setProperty("width", "64px"), n.style.setProperty("object-fit", "cover"), _(r, () => e.option.name, o), _(s, () => e.option.name, null), _(t, O(pa, {}), null), Y((a) => {
      var f = e.option.icon, l = e.option.name, c = {
        ...wt,
        "text-align": "center"
      }, u = xe;
      return f !== a.e && ee(n, "src", a.e = f), l !== a.t && ee(n, "alt", a.t = l), a.a = te(r, c, a.a), a.o = te(s, u, a.o), a;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0
    }), t;
  })();
}
var va = /* @__PURE__ */ M("<div><div tabindex=0><img><div>");
function ba(e) {
  function t() {
    e.onProviderSelected(e.id);
  }
  const n = V(() => ln(e) ? "button" : "link");
  function r(u) {
    if (n() === "link") {
      u.key === "Enter" && t();
      return;
    }
    if (n() === "button") {
      (u.key === "Enter" || u.key === " ") && t();
      return;
    }
  }
  const [i, o] = X(!1), [s, a] = X(!1), f = () => i() || s(), l = "rgba(24, 24, 24, 0.20)", c = "rgba(24, 24, 24, 0.60)";
  return (() => {
    var u = va(), d = u.firstChild, h = d.firstChild, g = h.nextSibling;
    return u.style.setProperty("aspect-ratio", "1 / 1"), u.style.setProperty("overflow", "hidden"), d.addEventListener("blur", () => a(!1)), d.addEventListener("focus", () => a(!0)), d.addEventListener("mouseleave", () => o(!1)), d.addEventListener("mouseenter", () => o(!0)), d.$$keydown = r, d.$$click = t, d.style.setProperty("display", "flex"), d.style.setProperty("flex-direction", "column"), d.style.setProperty("row-gap", "12px"), d.style.setProperty("align-items", "center"), d.style.setProperty("cursor", "pointer"), d.style.setProperty("outline", "none"), d.style.setProperty("padding-top", "10px"), h.style.setProperty("width", "56px"), h.style.setProperty("height", "56px"), h.style.setProperty("object-fit", "cover"), h.style.setProperty("border-radius", "12px"), _(g, () => e.name), Y((p) => {
      var P = n(), w = f() ? `6px solid ${l}` : "none", N = e.icon, $ = e.name, I = {
        ...xe,
        color: f() ? c : void 0,
        "text-align": "center"
      };
      return P !== p.e && ee(d, "role", p.e = P), w !== p.t && ((p.t = w) != null ? h.style.setProperty("outline", w) : h.style.removeProperty("outline")), N !== p.a && ee(h, "src", p.a = N), $ !== p.o && ee(h, "alt", p.o = $), p.i = te(g, I, p.i), p;
    }, {
      e: void 0,
      t: void 0,
      a: void 0,
      o: void 0,
      i: void 0
    }), u;
  })();
}
vt(["click", "keydown"]);
var ma = /* @__PURE__ */ M('<link href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&amp;display=swap"rel=stylesheet>'), wa = /* @__PURE__ */ M("<div class=side-panel>"), Ea = /* @__PURE__ */ M('<div class=card-grid><div class=main-panel><div class=wallets-grid-container data-desc="wallet grid container for padding"><div class=wallets-grid data-desc="wallet grid container">'), Pa = /* @__PURE__ */ M("<div class=card-width-container><div class=card-height-container>"), Sa = /* @__PURE__ */ M(`<div><style>
        @keyframes wallet-selector-fade-in {
          from {opacity: 0; transform: translateY(40px);}
          to {opacity: 1; transform: translateY(0);}
        }

        @keyframes wallet-selector-fade-out {
          from {opacity: 1; transform: translateY(0);}
          to {opacity: 0; transform: translateY(40px);}
        }
        @keyframes wallet-selector-blur-in {
          from {opacity: 0; backdrop-filter: blur(0px);}
          to {opacity: 1; backdrop-filter: blur(10px);}
        }

        @keyframes wallet-selector-blur-out {
          from {opacity: 1; backdrop-filter: blur(10px);}
          to {opacity: 0; backdrop-filter: blur(0px);}
        }
      </style><style>`);
const Xe = "24px";
function Ca() {
  const [e, t] = X(), [n, r] = X();
  function i() {
    const T = e(), j = n();
    return !(!T || !j || !T.contains(j) || getComputedStyle(j).display === "none");
  }
  const [o, s] = X(!1), [a, f] = X(!1), [l, c] = X([]), [u, d] = X({
    type: "none"
  }), h = () => l().some((T) => Oa(T)), g = () => s(!1);
  function p() {
    const T = new CustomEvent(Yt, {
      bubbles: !0,
      composed: !0
    });
    window.dispatchEvent(T), g();
  }
  function P(T) {
    const j = l().find((S) => S.id === T);
    if (ln(j)) {
      i() ? d({
        type: "install-wallet-prompt",
        option: j
      }) : Jt(j);
      return;
    }
    const C = new CustomEvent(Xt, {
      detail: T,
      bubbles: !0,
      composed: !0
    });
    window.dispatchEvent(C);
  }
  function w(T) {
    Un(() => {
      s(!0), f(!0);
      const j = T.detail.options;
      c(j), j.some((C) => !C.installPrompt) ? d({
        type: "explainer"
      }) : d({
        type: "none"
      });
    });
  }
  function N() {
    s(!1);
  }
  const $ = () => {
    o() || f(!1);
  };
  function I(T) {
    const j = T.detail;
    d({
      type: "opening-wallet",
      option: l().find((C) => C.id === j)
    });
  }
  function z() {
    d({
      type: "explainer"
    });
  }
  Qt(() => {
    window.addEventListener(Ht, w), window.addEventListener(Zt, N), window.addEventListener(xr, I), window.addEventListener(Ar, z), document.head.appendChild(ma());
  });
  function ne(T) {
    T.preventDefault(), p();
  }
  return gt(() => {
    window.removeEventListener(Ht, w), window.removeEventListener(Zt, N);
  }), (() => {
    var T = Sa(), j = T.firstChild, C = j.nextSibling;
    return hn(t, T), T.style.setProperty("inset", "0"), _(T, O(Qs, {}), j), _(C, () => `
        .card-width-container {
          container: card-width-container / inline-size;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: 740px;
        }

        .card-height-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;
          width: 100%;
        }

        .card {
          min-height: 340px;
          max-height: calc(100vh - 8rem);
          width: 100%;
          border-top-left-radius: ${Xe};
          border-top-right-radius: ${Xe};

          background: rgb(196, 177, 217);
          overflow: hidden;

          display: flex;
          flex-direction: column;

          position: "relative"; /* For the close button */
          background-color: #ffffff;
          display: ${a() ? "block" : "none"};

          box-shadow: 0px 8px 64px 0px rgba(0, 0, 0, 0.25);
          animation: ${o() ? "wallet-selector-fade-in 0.4s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-fade-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards"};
        }

        .card-grid {
          flex-grow: 1;
          height: 100%;
          
          display: grid;
          grid-template-columns: 1fr;
          grid-template-areas: "mainPanel";
        }

        .main-panel {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          grid-area: mainPanel;
        }

        .wallets-grid-container {
          overflow: auto;
          flex-grow: 1;
        }

        .wallets-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          align-content: start;

          padding-left: 24px;
          padding-right: 24px;
          padding-bottom: 40px;
        }

        .divider {
          display: none;
          grid-area: divider;
        }

        .side-panel {
          display: none;
          grid-area: sidePanel;
        }

        @container card-width-container (width > 400px) {
          .card-height-container {
            justify-content: center;
          }

          .card {
            max-width: calc(100vw - 2rem);
            max-height: 460px;
            ${h() ? "" : "width: 360px;"}
            border-bottom-left-radius: ${Xe};
            border-bottom-right-radius: ${Xe};
          }

          .card-grid {
            grid-template-columns: ${h() ? "5fr auto 4fr" : "1fr"};
            grid-template-areas: ${h() ? '"mainPanel divider sidePanel"' : '"mainPanel"'};
          }

          .divider {
            display: block;
          }

          .side-panel {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `), _(T, O(Pe, {
      get when() {
        return a();
      },
      get children() {
        return O(Vs, {
          getRootNode: () => {
            var S;
            return (S = e()) == null ? void 0 : S.getRootNode();
          },
          get open() {
            return a();
          },
          onEscapeKeyDown: ne,
          onInteractOutside: ne,
          onPointerDownOutside: ne,
          get children() {
            return [O(Ms, {
              get style() {
                return {
                  "background-color": "#FFFFFF80",
                  position: "absolute",
                  inset: "0",
                  animation: o() ? "wallet-selector-blur-in 0.2s cubic-bezier(.05, .7, .1, 1) forwards" : "wallet-selector-blur-out 0.2s cubic-bezier(.3, 0, .8, .15) forwards"
                };
              }
            }), O(zs, {
              style: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                height: "100%"
              },
              get children() {
                var S = Pa(), b = S.firstChild;
                return _(b, O(Bs, {
                  class: "card",
                  onAnimationEnd: $,
                  get children() {
                    return [(() => {
                      var y = Ea(), v = y.firstChild, m = v.firstChild, A = m.firstChild;
                      return _(v, O(Us, {
                        get style() {
                          return {
                            ...wt,
                            margin: "0",
                            "padding-top": "24px",
                            "padding-left": "24px",
                            "padding-right": "24px",
                            "padding-bottom": "16px"
                          };
                        },
                        get children() {
                          return h() ? "Choose wallet to connect" : "Don't have a wallet?";
                        }
                      }), m), _(v, O(Ks, {
                        get style() {
                          return {
                            ...xe,
                            "padding-left": "24px",
                            "padding-right": "24px",
                            "padding-bottom": "30px"
                          };
                        },
                        get children() {
                          return h() ? "Start by selecting with one of the wallets below and confirming the connection." : "Start by installing one of the wallets below.";
                        }
                      }), m), _(A, O(Jr, {
                        get each() {
                          return l();
                        },
                        children: (x) => O(ba, tn(x, {
                          onProviderSelected: P
                        }))
                      })), _(y, O(Pe, {
                        get when() {
                          return u().type !== "none";
                        },
                        get children() {
                          return O(ta, {});
                        }
                      }), null), _(y, O(Pe, {
                        get when() {
                          return u().type !== "none";
                        },
                        get children() {
                          var x = wa();
                          return hn(r, x), _(x, O(ra, {
                            get children() {
                              return O(oa, {
                                get children() {
                                  return O(Qr, {
                                    fallback: null,
                                    get children() {
                                      return [O(xt, {
                                        get when() {
                                          return u().type === "install-wallet-prompt";
                                        },
                                        get children() {
                                          return O(ua, {
                                            get option() {
                                              return u().option;
                                            }
                                          });
                                        }
                                      }), O(xt, {
                                        get when() {
                                          return u().type === "explainer";
                                        },
                                        get children() {
                                          return O(aa, {});
                                        }
                                      }), O(xt, {
                                        get when() {
                                          return u().type === "opening-wallet";
                                        },
                                        get children() {
                                          return O(ya, {
                                            get option() {
                                              return u().option;
                                            }
                                          });
                                        }
                                      })];
                                    }
                                  });
                                }
                              });
                            }
                          })), x;
                        }
                      }), null), y;
                    })(), O(Zs, {
                      onClose: p
                    })];
                  }
                })), S;
              }
            })];
          }
        });
      }
    }), null), Y(() => (a() ? "fixed" : "static") != null ? T.style.setProperty("position", a() ? "fixed" : "static") : T.style.removeProperty("position")), T;
  })();
}
const an = "sats-connect-wallet-provider-selector", It = an;
function Nr() {
  return document.getElementById(an);
}
function Na() {
  if (customElements.get(It))
    return;
  Pi(It, Ca);
  const e = document.createElement(It);
  e.id = an, document.body.appendChild(e);
}
function Ta() {
  const e = Nr();
  e && e.remove();
}
function ln(e) {
  return !!e.installPrompt;
}
function Oa(e) {
  return !ln(e);
}
function ka(e) {
  return new Promise((t, n) => {
    if (!Nr()) {
      n("Failed to detect the wallet provider selector.");
      return;
    }
    function i() {
      window.removeEventListener(Xt, o), window.removeEventListener(Yt, s);
    }
    function o(f) {
      t(f.detail), i();
    }
    function s() {
      n(), i();
    }
    window.addEventListener(Xt, o), window.addEventListener(Yt, s);
    const a = new CustomEvent(Ht, {
      detail: e
    });
    window.dispatchEvent(a);
  });
}
function Da(e) {
  const t = new CustomEvent(xr, {
    detail: e
  });
  window.dispatchEvent(t);
}
function La() {
  const e = new CustomEvent(Ar);
  window.dispatchEvent(e);
}
function $a() {
  const e = new CustomEvent(Zt);
  window.dispatchEvent(e);
}
export {
  Ta as cleanup,
  $a as close,
  an as elementId,
  It as elementName,
  Nr as getWalletProviderSelectorElement,
  ln as hasInstallPrompt,
  Oa as isInstalled,
  Na as loadSelector,
  ka as selectWalletProvider,
  La as walletClose,
  Da as walletOpen
};
